import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  shop_DateTime: { input: any; output: any; }
  shop_PTRScalarValue: { input: any; output: any; }
  shop_ScalarValue: { input: any; output: any; }
  shop_guru_Date: { input: any; output: any; }
  shop_inventory_Any: { input: any; output: any; }
  shop_inventory__Any: { input: any; output: any; }
  shop_inventory__FieldSet: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  shop_orderHistory_ISO8601DateTime: { input: any; output: any; }
  shop_previewReference_Any: { input: any; output: any; }
  shop_previewReference__Any: { input: any; output: any; }
  shop_previewReference__FieldSet: { input: any; output: any; }
};

export type Mutation = {
  __typename?: 'Mutation';
  shop_addComment?: Maybe<Shop_Comments_Comment>;
  shop_addGiftCardToCart: Scalars['Boolean']['output'];
  shop_addItemToDefaultList?: Maybe<Shop_Lists_AddItemToDefaultListPayload>;
  shop_addItemToList?: Maybe<Shop_Lists_AddItemToListPayload>;
  shop_addToCart?: Maybe<Shop_Cart_Cart>;
  shop_artistDomain_followArtist?: Maybe<Shop_ArtistDomain_FollowedArtist>;
  shop_artistDomain_unfollowArtist?: Maybe<Shop_ArtistDomain_FollowedArtist>;
  shop_cart_addInventoryItem?: Maybe<Shop_Cart_Cart>;
  shop_cart_addInventoryItems?: Maybe<Shop_Cart_Cart>;
  shop_comments_addComment?: Maybe<Shop_Comments_Comment>;
  shop_comments_deleteComment?: Maybe<Scalars['Boolean']['output']>;
  shop_createAnonymousUser?: Maybe<Shop_UserInfo>;
  shop_createList?: Maybe<Shop_Lists_CreateListPayload>;
  shop_deleteComment?: Maybe<Scalars['Boolean']['output']>;
  shop_lists_addItemToDefaultList?: Maybe<Shop_Lists_AddItemToDefaultListPayload>;
  shop_lists_addItemToList?: Maybe<Shop_Lists_AddItemToListPayload>;
  shop_lists_createList?: Maybe<Shop_Lists_CreateListPayload>;
  shop_lists_deleteList?: Maybe<Scalars['Boolean']['output']>;
  shop_lists_removeItemFromList?: Maybe<Shop_Lists_RemoveItemFromListPayload>;
  shop_lists_updateList?: Maybe<Shop_Lists_UpdateListPayload>;
  shop_removeItemFromList?: Maybe<Shop_Lists_RemoveItemFromListPayload>;
  shop_sendSearchEvent: Scalars['Boolean']['output'];
  shop_sendUserEvent: Scalars['Boolean']['output'];
  /** @deprecated Use the ArtistDomain followArtist and unFollowArtist mutations instead. */
  shop_setFollowArtist?: Maybe<Shop_FollowedArtist>;
  shop_toggleMatureContent: Shop_UserInfo;
  shop_updateList?: Maybe<Shop_Lists_UpdateListPayload>;
};


export type MutationShop_AddCommentArgs = {
  comment: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  workId: Scalars['String']['input'];
};


export type MutationShop_AddGiftCardToCartArgs = {
  amount: Scalars['Float']['input'];
};


export type MutationShop_AddItemToDefaultListArgs = {
  input: Shop_Lists_AddItemToDefaultListInput;
};


export type MutationShop_AddItemToListArgs = {
  input: Shop_Lists_AddItemToListInput;
};


export type MutationShop_AddToCartArgs = {
  inventoryItemId: Scalars['String']['input'];
  sailthruIds?: InputMaybe<Shop_Cart_SailthruIds>;
};


export type MutationShop_ArtistDomain_FollowArtistArgs = {
  artistId: Scalars['Int']['input'];
};


export type MutationShop_ArtistDomain_UnfollowArtistArgs = {
  artistId: Scalars['Int']['input'];
};


export type MutationShop_Cart_AddInventoryItemArgs = {
  inventoryItemId: Scalars['String']['input'];
  sailthruIds?: InputMaybe<Shop_Cart_SailthruIds>;
};


export type MutationShop_Cart_AddInventoryItemsArgs = {
  inventoryItemIds: Array<Scalars['String']['input']>;
  sailthruIds?: InputMaybe<Shop_Cart_SailthruIds>;
};


export type MutationShop_Comments_AddCommentArgs = {
  comment: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  workId: Scalars['String']['input'];
};


export type MutationShop_Comments_DeleteCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShop_CreateAnonymousUserArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationShop_CreateListArgs = {
  input: Shop_Lists_CreateListInput;
};


export type MutationShop_DeleteCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShop_Lists_AddItemToDefaultListArgs = {
  input: Shop_Lists_AddItemToDefaultListInput;
};


export type MutationShop_Lists_AddItemToListArgs = {
  input: Shop_Lists_AddItemToListInput;
};


export type MutationShop_Lists_CreateListArgs = {
  input: Shop_Lists_CreateListInput;
};


export type MutationShop_Lists_DeleteListArgs = {
  input: Shop_Lists_DeleteListInput;
};


export type MutationShop_Lists_RemoveItemFromListArgs = {
  input: Shop_Lists_RemoveItemFromListInput;
};


export type MutationShop_Lists_UpdateListArgs = {
  input: Shop_Lists_UpdateListInput;
};


export type MutationShop_RemoveItemFromListArgs = {
  input: Shop_Lists_RemoveItemFromListInput;
};


export type MutationShop_SendSearchEventArgs = {
  federatedId: Scalars['String']['input'];
  partialResults: Array<Shop_PartialResultsInput>;
  sailthruHid?: InputMaybe<Scalars['String']['input']>;
  searchContext: Shop_SearchContextInput;
};


export type MutationShop_SendUserEventArgs = {
  event: Shop_UserEventInput;
};


export type MutationShop_SetFollowArtistArgs = {
  artistId: Scalars['ID']['input'];
  follow: Scalars['Boolean']['input'];
};


export type MutationShop_ToggleMatureContentArgs = {
  show: Scalars['Boolean']['input'];
};


export type MutationShop_UpdateListArgs = {
  input: Shop_Lists_UpdateListInput;
};

export type Query = {
  __typename?: 'Query';
  shop_alternateProductPageUrls: Array<Maybe<Shop_AlternateProductPageUrl>>;
  shop_artistBadgeStatus: Array<Scalars['String']['output']>;
  shop_artistDomain_areFollowing: Array<Shop_ArtistDomain_FollowedArtist>;
  shop_artistDomain_following: Shop_ArtistDomain_FollowedArtistTypeConnection;
  shop_artistDomain_isFollowing: Shop_ArtistDomain_FollowedArtist;
  shop_artistInventoryItemPortfolio: Shop_RecommendedInventoryItems;
  shop_artistPortfolio?: Maybe<Shop_ArtistPortfolio>;
  shop_artistShopArtistInfo?: Maybe<Shop_ArtistShopArtistInfo>;
  shop_banners: Array<Maybe<Shop_Banner>>;
  shop_cart?: Maybe<Shop_Cart_Cart>;
  shop_cart_cart?: Maybe<Shop_Cart_Cart>;
  shop_collections?: Maybe<Array<Shop_Collection>>;
  shop_comments: Array<Shop_Comments_Comment>;
  shop_comments_comments: Array<Shop_Comments_Comment>;
  shop_defaultCategoryId?: Maybe<Scalars['String']['output']>;
  shop_deliveryDates?: Maybe<Shop_DeliveryDates>;
  shop_exploreWorks?: Maybe<Array<Maybe<Shop_ExploreWork>>>;
  shop_followedArtist: Shop_FollowedArtist;
  shop_giftCard?: Maybe<Shop_GiftCard>;
  shop_globalNavigation: Array<Shop_GlobalNavigationItem>;
  shop_guru_recommendationsForList: Shop_Guru_ListItemRecommendations;
  shop_guru_similarDesigns: Shop_Guru_InventoryItemRecommendations;
  shop_iaEntitiesCopy: Array<Maybe<Shop_IaEntityCopy>>;
  /** Catalogue of inventory items and available configuration options for the given category and work */
  shop_inventory_categorySet?: Maybe<Shop_Inventory_CategorySet>;
  /**
   * Default inventory items for the given categories and work.
   *
   * If productTypeIds is null, you will receive all productTypeIds for a work.
   * If productTypeIds is empty, you will receive an empty list.
   */
  shop_inventory_defaultInventoryItems?: Maybe<Array<Maybe<Shop_Inventory_InventoryItemsItem>>>;
  /** Inventory item lookup for the given inventory item ID */
  shop_inventory_inventoryItem?: Maybe<Shop_Inventory_InventoryItem>;
  /** Inventory items lookup for the given inventory item IDs */
  shop_inventory_inventoryItems?: Maybe<Array<Maybe<Shop_Inventory_InventoryItemsItem>>>;
  /**
   * Size guide table for the given product type ID by locale.
   * Does not support category/family IDs. Work ID is required.
   *
   * inventoryItemId has no effect other than to be validated, and may be deprecated. The
   * product type in inventoryItemId MUST match productTypeId, the work ID in inventoryItemID
   * MUST match workId.
   */
  shop_inventory_sizeGuide?: Maybe<Shop_Inventory_DimensionGuide>;
  shop_inventory_works: Array<Shop_Inventory_Work>;
  shop_landingPage?: Maybe<Shop_LandingPage>;
  shop_licensedInventoryItems: Shop_RecommendedInventoryItems;
  shop_licensingMarks: Array<Shop_LicensingMark>;
  shop_list?: Maybe<Shop_Lists_List>;
  shop_lists_favoritesList?: Maybe<Shop_Lists_List>;
  shop_lists_inclusions?: Maybe<Array<Shop_Lists_Inclusion>>;
  shop_lists_list?: Maybe<Shop_Lists_List>;
  shop_lists_lists?: Maybe<Shop_Lists_Lists>;
  shop_orderHistory_findOrder?: Maybe<Shop_OrderHistory_FoundOrder>;
  shop_orderHistory_giftOrder?: Maybe<Shop_OrderHistory_GiftOrder>;
  shop_orderHistory_purchaseOrder?: Maybe<Shop_OrderHistory_PurchaseOrder>;
  shop_orderHistory_purchaseOrderHistory?: Maybe<Shop_OrderHistory_PurchaseOrderConnection>;
  shop_otherProducts: Array<Shop_Inventory_InventoryItemsItem>;
  /** Product url lookup for Inventory Item IDs returning all localised variants */
  shop_previewReference_localisedProductUrls: Array<Shop_PreviewReference_ProductUrlItem>;
  /** Default product url lookup for Inventory Item ID, locale, and group ID */
  shop_previewReference_productUrl?: Maybe<Shop_PreviewReference_ProductUrl>;
  shop_productTypes: Array<Maybe<Shop_PtrProductType>>;
  shop_promotions_volumeDiscount?: Maybe<Shop_Promotions_VolumeDiscount>;
  shop_promotions_volumeDiscounts?: Maybe<Array<Shop_Promotions_ApplicableVolumeDiscount>>;
  shop_recommendedInventoryItems: Shop_RecommendedInventoryItems;
  shop_reviewSet?: Maybe<Shop_ReviewSet>;
  shop_reviewSummary?: Maybe<Shop_ReviewSummary>;
  shop_searchResults: Shop_SearchResults;
  shop_sessionContext: Shop_SessionContext;
  shop_userAccount?: Maybe<Shop_UserAccount>;
  shop_userInfo: Shop_UserInfo;
  shop_work?: Maybe<Shop_Inventory_Work>;
  shop_workImages?: Maybe<Array<Maybe<Shop_WorkImage>>>;
};


export type QueryShop_AlternateProductPageUrlsArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  inventoryItemId: Scalars['String']['input'];
};


export type QueryShop_ArtistBadgeStatusArgs = {
  federatedId: Scalars['String']['input'];
};


export type QueryShop_ArtistDomain_AreFollowingArgs = {
  artistIds: Array<Scalars['Int']['input']>;
};


export type QueryShop_ArtistDomain_FollowingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShop_ArtistDomain_IsFollowingArgs = {
  artistId: Scalars['Int']['input'];
};


export type QueryShop_ArtistInventoryItemPortfolioArgs = {
  artistUsername: Scalars['String']['input'];
  inventoryItemId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: Scalars['String']['input'];
};


export type QueryShop_ArtistPortfolioArgs = {
  artistUsername: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};


export type QueryShop_ArtistShopArtistInfoArgs = {
  artistName: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
};


export type QueryShop_BannersArgs = {
  audience?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShop_CollectionsArgs = {
  numberOfWorks: Scalars['Int']['input'];
  workId: Scalars['Int']['input'];
};


export type QueryShop_CommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  workId: Scalars['String']['input'];
};


export type QueryShop_Comments_CommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  workId: Scalars['String']['input'];
};


export type QueryShop_DefaultCategoryIdArgs = {
  blankItemId: Scalars['String']['input'];
};


export type QueryShop_DeliveryDatesArgs = {
  countryCode: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  productTypeId: Scalars['String']['input'];
  timezoneOffset: Scalars['String']['input'];
};


export type QueryShop_ExploreWorksArgs = {
  workIds: Array<Scalars['Int']['input']>;
};


export type QueryShop_FollowedArtistArgs = {
  artistId: Scalars['ID']['input'];
};


export type QueryShop_GiftCardArgs = {
  code: Scalars['String']['input'];
};


export type QueryShop_GlobalNavigationArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShop_Guru_RecommendationsForListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  listInputItems: Array<Shop_Guru_ListInputItem>;
  locale?: InputMaybe<Shop_Guru_Locale>;
};


export type QueryShop_Guru_SimilarDesignsArgs = {
  inventoryItemId: Scalars['String']['input'];
  isBot?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShop_IaEntitiesCopyArgs = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locale: Scalars['String']['input'];
};


export type QueryShop_Inventory_CategorySetArgs = {
  categoryId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds: Array<Scalars['String']['input']>;
  unit: Shop_Inventory_Unit;
  workId: Scalars['Int']['input'];
};


export type QueryShop_Inventory_DefaultInventoryItemsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  unit: Shop_Inventory_Unit;
  workId: Scalars['Int']['input'];
};


export type QueryShop_Inventory_InventoryItemArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  unit: Shop_Inventory_Unit;
};


export type QueryShop_Inventory_InventoryItemsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  unit: Shop_Inventory_Unit;
};


export type QueryShop_Inventory_SizeGuideArgs = {
  inventoryItemId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  productTypeId: Scalars['String']['input'];
  workId: Scalars['Int']['input'];
};


export type QueryShop_Inventory_WorksArgs = {
  locale: Scalars['String']['input'];
  workIds: Array<Scalars['Int']['input']>;
};


export type QueryShop_LandingPageArgs = {
  locale: Scalars['String']['input'];
  pagePathPrefix: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryShop_LicensedInventoryItemsArgs = {
  artistUsername: Scalars['String']['input'];
  famProperty: Scalars['String']['input'];
  inventoryItemId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: Scalars['String']['input'];
};


export type QueryShop_LicensingMarksArgs = {
  workId: Scalars['Int']['input'];
};


export type QueryShop_ListArgs = {
  input: Shop_Lists_ListInput;
};


export type QueryShop_Lists_FavoritesListArgs = {
  input: Shop_Lists_FavoritesListInput;
};


export type QueryShop_Lists_InclusionsArgs = {
  input: Shop_Lists_InclusionsInput;
};


export type QueryShop_Lists_ListArgs = {
  input: Shop_Lists_ListInput;
};


export type QueryShop_Lists_ListsArgs = {
  input?: InputMaybe<Shop_Lists_ListsInput>;
};


export type QueryShop_OrderHistory_FindOrderArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QueryShop_OrderHistory_GiftOrderArgs = {
  externalGiftId: Scalars['ID']['input'];
};


export type QueryShop_OrderHistory_PurchaseOrderArgs = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QueryShop_OrderHistory_PurchaseOrderHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShop_OtherProductsArgs = {
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  inventoryItemId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  previewTypeIds: Array<Scalars['String']['input']>;
};


export type QueryShop_PreviewReference_LocalisedProductUrlsArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  inventoryItemIds: Array<Scalars['ID']['input']>;
  strict?: Scalars['Boolean']['input'];
};


export type QueryShop_PreviewReference_ProductUrlArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  inventoryItemId: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
};


export type QueryShop_ProductTypesArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShop_Promotions_VolumeDiscountArgs = {
  inventoryItemId: Scalars['String']['input'];
};


export type QueryShop_Promotions_VolumeDiscountsArgs = {
  inventoryItemIds: Array<Scalars['String']['input']>;
};


export type QueryShop_RecommendedInventoryItemsArgs = {
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  inventoryItemId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  searchType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShop_ReviewSetArgs = {
  inventoryItemId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};


export type QueryShop_ReviewSummaryArgs = {
  inventoryItemId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};


export type QueryShop_SearchResultsArgs = {
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  experience?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  query: Scalars['String']['input'];
  queryParams?: InputMaybe<Shop_QueryParams>;
};


export type QueryShop_WorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  workId: Scalars['Int']['input'];
};


export type QueryShop_WorkImagesArgs = {
  previewSize?: InputMaybe<Scalars['String']['input']>;
  workIds: Array<Scalars['Int']['input']>;
};

export type Shop_AlternatePageVersion = {
  __typename?: 'shop_AlternatePageVersion';
  href: Scalars['String']['output'];
  locale: Scalars['String']['output'];
};

export type Shop_AlternateProductPageUrl = {
  __typename?: 'shop_AlternateProductPageUrl';
  locale: Scalars['String']['output'];
  productUrl?: Maybe<Shop_PreviewReference_ProductUrl>;
  url: Scalars['String']['output'];
};


export type Shop_AlternateProductPageUrlProductUrlArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  inventoryItemId: Scalars['String']['input'];
};

export type Shop_Analytics = Shop_Domain & {
  __typename?: 'shop_Analytics';
  /** @deprecated Use productType.tracking.gaCode */
  attributes: Array<Maybe<Shop_PtrAttribute>>;
};

export type Shop_Artist = {
  __typename?: 'shop_Artist';
  analyticsCode?: Maybe<Scalars['String']['output']>;
  avatar: Scalars['String']['output'];
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  established: Scalars['Boolean']['output'];
  externalSites: Array<Shop_ExternalSite>;
  fanArtist: Scalars['Boolean']['output'];
  featuredArtist: Scalars['Boolean']['output'];
  followerCount?: Maybe<Scalars['Int']['output']>;
  followingCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  joinedDate: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  portfolio: Shop_ArtistPortfolio;
  portfolioUrl?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  shopDisplayName: Scalars['String']['output'];
  shopUrl?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type Shop_ArtistCollection = {
  __typename?: 'shop_ArtistCollection';
  applied: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Shop_ArtistCollections = {
  __typename?: 'shop_ArtistCollections';
  applied: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Array<Shop_ArtistCollection>;
  reset?: Maybe<Shop_SearchFilterResets>;
  type: Scalars['String']['output'];
};

export type Shop_ArtistCoverImages = {
  __typename?: 'shop_ArtistCoverImages';
  size?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Shop_ArtistMetrics = {
  __typename?: 'shop_ArtistMetrics';
  favoriteReceivedCount: Scalars['Int']['output'];
  followerCount: Scalars['Int']['output'];
  followingCount: Scalars['Int']['output'];
};

export type Shop_ArtistPortfolio = {
  __typename?: 'shop_ArtistPortfolio';
  id: Scalars['ID']['output'];
  works?: Maybe<Array<Shop_Inventory_Work>>;
};

export type Shop_ArtistShopArtistInfo = {
  __typename?: 'shop_ArtistShopArtistInfo';
  acceptPrivateMessages: Scalars['Boolean']['output'];
  accountState: Shop_ArtistState;
  additionalInfo?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  bannerUrls: Array<Maybe<Shop_ArtistCoverImages>>;
  bio?: Maybe<Scalars['String']['output']>;
  externalSites: Array<Shop_ExternalSite>;
  featuredCollection?: Maybe<Scalars['String']['output']>;
  federatedId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isArtist: Scalars['Boolean']['output'];
  metrics: Shop_ArtistMetrics;
  name?: Maybe<Scalars['String']['output']>;
  shopDisplayName: Scalars['String']['output'];
  usBusinessInfo?: Maybe<Shop_UsBusinessInfo>;
  username?: Maybe<Scalars['String']['output']>;
  worksCount: Scalars['Int']['output'];
};

export enum Shop_ArtistState {
  Active = 'ACTIVE',
  Anonymous = 'ANONYMOUS',
  Deleted = 'DELETED',
  Restricted = 'RESTRICTED',
  Suspended = 'SUSPENDED',
  System = 'SYSTEM'
}

export type Shop_Attribute = {
  __typename?: 'shop_Attribute';
  attributes: Array<Shop_Attribute>;
  name: Scalars['String']['output'];
  value: Scalars['shop_ScalarValue']['output'];
};

export type Shop_AttributeInput = {
  attributes: Array<Shop_AttributeInput>;
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Shop_Banner = {
  __typename?: 'shop_Banner';
  audience: Scalars['String']['output'];
  endDate: Scalars['shop_DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type Shop_Base64Image = {
  __typename?: 'shop_Base64Image';
  data?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type Shop_BlankItem = {
  __typename?: 'shop_BlankItem';
  /**
   * The 'active' field is true if lifecycleStage == ACTIVE
   * @deprecated Use lifecycleStage
   */
  active: Scalars['Boolean']['output'];
  /**
   * @deprecated NOTE: If the deprecated 'domain' is not used, this will be empty.
   * Use productType options.
   */
  attributes: Array<Maybe<Shop_PtrAttribute>>;
  blankItemId: Scalars['String']['output'];
  /** @deprecated Use blankItemId */
  id: Scalars['String']['output'];
  /** internalDescription MUST NOT be used in customer-facing contexts */
  internalDescription: Scalars['String']['output'];
  /** @deprecated Use productType options */
  shopAttributes: Array<Maybe<Shop_PtrAttribute>>;
};

export type Shop_BlankItemReferral = {
  __typename?: 'shop_BlankItemReferral';
  /** @deprecated Use sourceBlankItemId */
  source?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use targetBlankItemId */
  target?: Maybe<Scalars['String']['output']>;
};

export type Shop_Breadcrumb = {
  __typename?: 'shop_Breadcrumb';
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Shop_Cart = {
  __typename?: 'shop_Cart';
  id: Scalars['ID']['output'];
  itemsCount: Scalars['Int']['output'];
};

export type Shop_Collection = {
  __typename?: 'shop_Collection';
  collectionId?: Maybe<Scalars['Int']['output']>;
  collectionUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  workIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  works?: Maybe<Array<Shop_Inventory_Work>>;
};


export type Shop_CollectionWorksArgs = {
  locale: Scalars['String']['input'];
};

export type Shop_DeliveryDateRange = {
  __typename?: 'shop_DeliveryDateRange';
  daysLeftToOrder?: Maybe<Scalars['Int']['output']>;
  high?: Maybe<Scalars['String']['output']>;
  low?: Maybe<Scalars['String']['output']>;
  targetDate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Shop_DeliveryDates = {
  __typename?: 'shop_DeliveryDates';
  express?: Maybe<Shop_DeliveryDateRange>;
  standard?: Maybe<Shop_DeliveryDateRange>;
};

export type Shop_Domain = {
  attributes: Array<Maybe<Shop_PtrAttribute>>;
};

export type Shop_Enrolment = {
  __typename?: 'shop_Enrolment';
  experiment: Scalars['String']['output'];
  group: Scalars['String']['output'];
};

export type Shop_ExploreWork = {
  __typename?: 'shop_ExploreWork';
  imageUrl?: Maybe<Scalars['String']['output']>;
  workId?: Maybe<Scalars['String']['output']>;
};

export type Shop_ExternalSite = {
  __typename?: 'shop_ExternalSite';
  label: Scalars['String']['output'];
  site: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Shop_FaqItem = {
  __typename?: 'shop_FAQItem';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type Shop_FilterItem = {
  __typename?: 'shop_FilterItem';
  all?: Maybe<Array<Scalars['String']['output']>>;
  applied?: Maybe<Array<Scalars['String']['output']>>;
  available?: Maybe<Array<Scalars['String']['output']>>;
  type: Scalars['String']['output'];
};

export type Shop_FollowedArtist = {
  __typename?: 'shop_FollowedArtist';
  isFollowed: Scalars['Boolean']['output'];
};

export type Shop_GiftCard = {
  __typename?: 'shop_GiftCard';
  amount?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  remainingAmount?: Maybe<Scalars['Float']['output']>;
};

export type Shop_GlobalNavigationItem = {
  __typename?: 'shop_GlobalNavigationItem';
  action: Shop_GlobalNavigationItemAction;
  badge?: Maybe<Shop_GlobalNavigationItemBadge>;
  banner?: Maybe<Shop_GlobalNavigationItemImageSet>;
  color?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Shop_GlobalNavigationItemImageSet>;
  id: Scalars['ID']['output'];
  items: Array<Shop_GlobalNavigationItem>;
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type Shop_GlobalNavigationItemAction = {
  __typename?: 'shop_GlobalNavigationItemAction';
  parameters: Shop_GlobalNavigationItemActionParameters;
  type: Scalars['String']['output'];
};

export type Shop_GlobalNavigationItemActionParameters = {
  __typename?: 'shop_GlobalNavigationItemActionParameters';
  url: Scalars['String']['output'];
  urlType: Scalars['String']['output'];
};

export type Shop_GlobalNavigationItemBadge = {
  __typename?: 'shop_GlobalNavigationItemBadge';
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Shop_GlobalNavigationItemImage = {
  __typename?: 'shop_GlobalNavigationItemImage';
  descriptor: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Shop_GlobalNavigationItemImageSet = {
  __typename?: 'shop_GlobalNavigationItemImageSet';
  set: Array<Shop_GlobalNavigationItemImage>;
  url: Scalars['String']['output'];
};

export type Shop_IaEntityCopy = {
  __typename?: 'shop_IaEntityCopy';
  canonicalForm: Scalars['String']['output'];
  iaCode: Scalars['String']['output'];
  label: Scalars['String']['output'];
  pluralDisplayName: Scalars['String']['output'];
};

export type Shop_Inventory = Shop_Domain & {
  __typename?: 'shop_Inventory';
  /** @deprecated Use ProductType.productFamilyId */
  attributes: Array<Maybe<Shop_PtrAttribute>>;
  /** @deprecated Use ProductType.blankItems */
  blankItems: Array<Maybe<Shop_BlankItem>>;
  /** @deprecated Use ProductType.defaultBlankItemId */
  defaultItem: Scalars['String']['output'];
  /** @deprecated Use ProductType.rawLegacyReference */
  legacyReference?: Maybe<Shop_PtrLegacyReference>;
};

export type Shop_LandingPage = {
  __typename?: 'shop_LandingPage';
  components: Array<Shop_LandingPageComponent>;
  metadata: Shop_LandingPageMetadata;
  searchBarContext?: Maybe<Shop_LandingPageSearchBarContext>;
  slug: Scalars['String']['output'];
};

export type Shop_LandingPageAlertBanner = {
  __typename?: 'shop_LandingPageAlertBanner';
  message: Scalars['String']['output'];
};

export type Shop_LandingPageAlternateUrl = {
  __typename?: 'shop_LandingPageAlternateUrl';
  locale?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Shop_LandingPageBlogPost = {
  __typename?: 'shop_LandingPageBlogPost';
  imageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Shop_LandingPageBlogPosts = {
  __typename?: 'shop_LandingPageBlogPosts';
  posts: Array<Shop_LandingPageBlogPost>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Shop_LandingPageCategoryBubble = {
  __typename?: 'shop_LandingPageCategoryBubble';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  bubbleImageUrl: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  subHeading: Scalars['String']['output'];
  textColor?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type Shop_LandingPageCategoryBubbleList = {
  __typename?: 'shop_LandingPageCategoryBubbleList';
  categories: Array<Shop_LandingPageCategoryBubble>;
};

export type Shop_LandingPageCategoryCard = {
  __typename?: 'shop_LandingPageCategoryCard';
  imageUrl: Scalars['String']['output'];
  path: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Shop_LandingPageCategoryCards = {
  __typename?: 'shop_LandingPageCategoryCards';
  cards: Array<Shop_LandingPageCategoryCard>;
  isSquare?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Shop_LandingPageComponent = Shop_LandingPageAlertBanner | Shop_LandingPageBlogPosts | Shop_LandingPageCategoryBubbleList | Shop_LandingPageCategoryCards | Shop_LandingPageFaq | Shop_LandingPageFeaturedPoints | Shop_LandingPageFooter | Shop_LandingPageHeroBanner | Shop_LandingPageInventoryItemsCarousel | Shop_LandingPageProductCarousel | Shop_LandingPageProductGrid | Shop_LandingPageTabbedList | Shop_LandingPageTagsCarousel | Shop_LandingPageTrustSignals;

export type Shop_LandingPageFaq = {
  __typename?: 'shop_LandingPageFAQ';
  items: Array<Maybe<Shop_FaqItem>>;
  title: Scalars['String']['output'];
};

export type Shop_LandingPageFeaturedPoints = {
  __typename?: 'shop_LandingPageFeaturedPoints';
  callToActionPath?: Maybe<Scalars['String']['output']>;
  callToActionTitle?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  imageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Shop_LandingPageFooter = {
  __typename?: 'shop_LandingPageFooter';
  contents: Scalars['String']['output'];
  readMoreContents?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Shop_LandingPageHeroBanner = {
  __typename?: 'shop_LandingPageHeroBanner';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  bannerImageUrl: Scalars['String']['output'];
  callToAction: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  subHeading: Scalars['String']['output'];
  textColor?: Maybe<Scalars['String']['output']>;
};

export type Shop_LandingPageInventoryItemsCarousel = {
  __typename?: 'shop_LandingPageInventoryItemsCarousel';
  inventoryItems: Array<Shop_SearchResult>;
  seeAll: Scalars['String']['output'];
  seeAllPath: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Shop_LandingPageMetadata = {
  __typename?: 'shop_LandingPageMetadata';
  alternateUrls?: Maybe<Array<Maybe<Shop_LandingPageAlternateUrl>>>;
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Shop_LandingPageProductCarousel = {
  __typename?: 'shop_LandingPageProductCarousel';
  numberOfResults: Scalars['Int']['output'];
  query: Scalars['String']['output'];
  seeAll: Scalars['String']['output'];
  seeAllPath: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Shop_LandingPageProductGrid = {
  __typename?: 'shop_LandingPageProductGrid';
  numberOfResults: Scalars['Int']['output'];
  query: Scalars['String']['output'];
  seeAll: Scalars['String']['output'];
  seeAllPath: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Shop_LandingPageSearchBarContext = {
  __typename?: 'shop_LandingPageSearchBarContext';
  iaCode?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type Shop_LandingPageTabbedList = {
  __typename?: 'shop_LandingPageTabbedList';
  errorMessage: Scalars['String']['output'];
  seeAllTitle: Scalars['String']['output'];
  tabTitle: Scalars['String']['output'];
  tabs: Array<Shop_LandingPageTabbedListTab>;
};

export type Shop_LandingPageTabbedListTab = {
  __typename?: 'shop_LandingPageTabbedListTab';
  numberOfResults: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  queryTerm: Scalars['String']['output'];
  topicName: Scalars['String']['output'];
};

export type Shop_LandingPageTagsCarousel = {
  __typename?: 'shop_LandingPageTagsCarousel';
  slides: Array<Shop_LandingPageTagsCarouselTag>;
  title: Scalars['String']['output'];
};

export type Shop_LandingPageTagsCarouselTag = {
  __typename?: 'shop_LandingPageTagsCarouselTag';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  textColor?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Shop_LandingPageTrustSignals = {
  __typename?: 'shop_LandingPageTrustSignals';
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Implementation of PTR LegacyReference */
export type Shop_LegacyReference = {
  __typename?: 'shop_LegacyReference';
  typeCode: Scalars['String']['output'];
  typeOptions: Array<Shop_LegacyTypeOptionValue>;
};

/** Input implementation of PTR LegacyReference */
export type Shop_LegacyReferenceInput = {
  typeCode: Scalars['String']['input'];
  typeOptions: Array<Shop_LegacyTypeOptionValueInput>;
};

export type Shop_LegacyTypeOptionValue = {
  __typename?: 'shop_LegacyTypeOptionValue';
  name: Scalars['String']['output'];
  value: Scalars['shop_PTRScalarValue']['output'];
};

/** Input implementation of PTR LegacyTypeOptionValue */
export type Shop_LegacyTypeOptionValueInput = {
  name: Scalars['String']['input'];
  value: Scalars['shop_ScalarValue']['input'];
};

export type Shop_LicensingMark = {
  __typename?: 'shop_LicensingMark';
  agreementId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageSrc: Scalars['String']['output'];
  intellectualPropertyName: Scalars['String']['output'];
  legalLine: Scalars['String']['output'];
  rightsholderName: Scalars['String']['output'];
};

export type Shop_List = {
  __typename?: 'shop_List';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  listId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Shop_MarketingProductType = Shop_Domain & {
  __typename?: 'shop_MarketingProductType';
  /** @deprecated See ProductType.marketingProductType */
  attributes: Array<Maybe<Shop_PtrAttribute>>;
};

export type Shop_NamedLink = {
  __typename?: 'shop_NamedLink';
  rel: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Shop_NamedLinks = {
  __typename?: 'shop_NamedLinks';
  nextPage?: Maybe<Shop_NamedLink>;
  previousPage?: Maybe<Shop_NamedLink>;
};

export type Shop_PtrAttribute = {
  __typename?: 'shop_PTRAttribute';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['shop_PTRScalarValue']['output']>;
};

export type Shop_PtrLegacyReference = {
  __typename?: 'shop_PTRLegacyReference';
  default: Scalars['Boolean']['output'];
  typeCode: Scalars['String']['output'];
  typeOptions: Array<Maybe<Shop_LegacyTypeOptionValue>>;
};

export type Shop_PtrProductType = {
  __typename?: 'shop_PTRProductType';
  /**
   * BlankItems should be accessed via this field rather than via domain.blankItems.
   * The lifecycleStage input values will take precedence over the domain's lifecycle stage
   * when both are passed for blankItems at this level, whereas the domain always applies to
   * domain.blankItems.
   */
  blankItems: Array<Shop_BlankItem>;
  /**
   * defaultBlankItemId may be null if a product is in the 'DEVELOPING' stage
   * and has no blank items
   */
  defaultBlankItemId?: Maybe<Scalars['String']['output']>;
  /**
   * defaultCategoryId is a legacy field to refer to the productFamilyId
   * @deprecated Use productFamilyId
   */
  defaultCategoryId?: Maybe<Scalars['String']['output']>;
  /**
   * defaultColistGrouping refers to a productTypeGrouping in the namespace 'colist'
   * @deprecated Will always return null. will be removed at a later date.
   */
  defaultColistGrouping?: Maybe<Scalars['String']['output']>;
  deliveryDateCode?: Maybe<Scalars['String']['output']>;
  /**
   * @deprecated All data is available outside domain. Note that this will only be populated
   * if you passed in a domain to productTypes(). Nothing new will be added to
   * domain, and everything that was once available only via domain should be
   * available at the ProductType/BlankItem level.
   */
  domain: Shop_Domain;
  /** @deprecated Use productTypeId */
  id: Scalars['String']['output'];
  /** internalName MUST NOT be used in customer-facing contexts */
  internalName: Scalars['String']['output'];
  marketingProductType?: Maybe<Scalars['String']['output']>;
  pricingGroup?: Maybe<Scalars['String']['output']>;
  /**
   * If set, when a PDP is requested on shop/frontend, and the IHS' categorySet field
   * is called, this will be passed as the productFamilyId (categoryId). If not set, the
   * productTypeId is used instead.
   */
  productFamilyId?: Maybe<Scalars['String']['output']>;
  productTypeId: Scalars['String']['output'];
  /**
   * rawLegacyReference contains a soon-to-be-deprecated version of a legacy reference.
   * The reason for this interim move is because LegacyReference is under-typed, we don't
   * yet know enough to fully type it (not until we tackle the configurationSet), but we
   * need to hoist it out of domains immediately.
   */
  rawLegacyReference?: Maybe<Shop_PtrLegacyReference>;
};

export type Shop_Pagination = {
  __typename?: 'shop_Pagination';
  currentPage?: Maybe<Scalars['Int']['output']>;
  fromNumber?: Maybe<Scalars['Int']['output']>;
  paginationLinks?: Maybe<Shop_PaginationLinks>;
  perPage?: Maybe<Scalars['Int']['output']>;
  showNextPageLink?: Maybe<Scalars['Boolean']['output']>;
  showPreviousPageLink?: Maybe<Scalars['Boolean']['output']>;
  toNumber?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Shop_PaginationLinks = {
  __typename?: 'shop_PaginationLinks';
  namedLinks?: Maybe<Shop_NamedLinks>;
};

export type Shop_PartialResultsInput = {
  artistUserName: Scalars['String']['input'];
  fullTitle: Scalars['String']['input'];
  inventoryItemId: Scalars['String']['input'];
  matureContent: Scalars['Boolean']['input'];
  primaryImage: Scalars['String']['input'];
  productUrl: Scalars['String']['input'];
};

export type Shop_Preview = {
  __typename?: 'shop_Preview';
  previewTypeId: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Shop_PreviewReference = {
  __typename?: 'shop_PreviewReference';
  previewReferenceId: Scalars['String']['output'];
  /** @deprecated Use previewReferenceId */
  reference: Scalars['String']['output'];
  /**
   * XXX: tag is NOT a previewReferenceId, even though it looks a lot like one.
   * It's used by integrating systems to distinguish different groupings of
   * previews.
   *
   * NOTE: tag may be an empty string
   */
  tag: Scalars['String']['output'];
};

export type Shop_Price = {
  __typename?: 'shop_Price';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Shop_ProductCard = Shop_Domain & {
  __typename?: 'shop_ProductCard';
  /** @deprecated There are no attributes */
  attributes: Array<Maybe<Shop_PtrAttribute>>;
  /** @deprecated See ProductType.shop.showCardQuickAddToCart */
  experiences: Array<Shop_PtrAttribute>;
};

export type Shop_ProductPage = Shop_Domain & {
  __typename?: 'shop_ProductPage';
  /**
   * @deprecated Attributes have been promoted to productType:
   * gaCode -> ProductType.tracking.gaCode
   * tagCloudIaCode -> ProductType.iaCodes.tagCloud
   * seoProductCategory -> ProductType.productPageSeoCategory
   * defaultCategory -> ProductType.productFamilyId
   */
  attributes: Array<Maybe<Shop_PtrAttribute>>;
  /** @deprecated Use the properties in ProductType.shop */
  experiences: Array<Shop_PtrAttribute>;
  /** @deprecated Use ProductType.previews.shopProductPageGallery */
  gallery?: Maybe<Array<Maybe<Shop_PreviewReference>>>;
  /** @deprecated Use ProductType.rawLegacyReference */
  legacyReference?: Maybe<Shop_PtrLegacyReference>;
  /** @deprecated Use ProductType.previews.shopProductPageThumbnails */
  previews?: Maybe<Array<Maybe<Shop_PreviewReference>>>;
  /**
   * The list of blank item referrals coming _in_ to this product.
   *
   * Each mapping consists of a source blank item ID, which will be SUNSET,
   * to a target blank item id, which will be ACTIVE.
   *
   * The referrals contained in this array will _always_ have blank items for this
   * product type as the _target_.
   *
   * You should not need to chase referrals. The target of a referral must not
   * itself refer to another blank item ID.
   * @deprecated Use the top level blankItemReferrals
   */
  referrals?: Maybe<Array<Maybe<Shop_BlankItemReferral>>>;
};

export type Shop_ProductRecommendation = {
  __typename?: 'shop_ProductRecommendation';
  alt: Scalars['String']['output'];
  href: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  inventoryItem?: Maybe<Shop_Inventory_InventoryItem>;
  inventoryItemId?: Maybe<Scalars['String']['output']>;
  matureContent: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: Shop_Price;
  title: Scalars['String']['output'];
};


export type Shop_ProductRecommendationInventoryItemArgs = {
  locale: Scalars['String']['input'];
  unit: Shop_Inventory_Unit;
};

export type Shop_ProductRecommendationSet = {
  __typename?: 'shop_ProductRecommendationSet';
  id: Scalars['String']['output'];
  recommendations: Array<Shop_ProductRecommendation>;
};

export type Shop_QueryParamItem = {
  name: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

/** Parameters for calls to search-service endpoints */
export type Shop_QueryParams = {
  artistUserName?: InputMaybe<Scalars['String']['input']>;
  cat_context?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<Scalars['String']['input']>;
  featuredArtist?: InputMaybe<Scalars['Boolean']['input']>;
  iaCode?: InputMaybe<Scalars['String']['input']>;
  includeSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  queryParamItems?: InputMaybe<Array<Shop_QueryParamItem>>;
  rbs?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
  showMatureContent?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type Shop_RecommendedInventoryItem = {
  __typename?: 'shop_RecommendedInventoryItem';
  defaultPreviewTypeId?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  inventoryItem?: Maybe<Shop_Inventory_InventoryItemsItem>;
  inventoryItemId: Scalars['String']['output'];
  work?: Maybe<Shop_SearchResultWork>;
  workId: Scalars['String']['output'];
};


export type Shop_RecommendedInventoryItemInventoryItemArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type Shop_RecommendedInventoryItemWorkArgs = {
  locale: Scalars['String']['input'];
};

export type Shop_RecommendedInventoryItems = {
  __typename?: 'shop_RecommendedInventoryItems';
  id: Scalars['ID']['output'];
  results?: Maybe<Array<Maybe<Shop_RecommendedInventoryItem>>>;
};

export type Shop_Review = {
  __typename?: 'shop_Review';
  authorName: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['String']['output'];
  productTypeId: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type Shop_ReviewSet = {
  __typename?: 'shop_ReviewSet';
  id: Scalars['ID']['output'];
  reviews: Array<Shop_Review>;
};

export type Shop_ReviewSummary = {
  __typename?: 'shop_ReviewSummary';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  rating: Scalars['Float']['output'];
};

export type Shop_SeoMetadataRelatedTagLink = {
  __typename?: 'shop_SEOMetadataRelatedTagLink';
  href: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Shop_SearchCategoryGroup = {
  __typename?: 'shop_SearchCategoryGroup';
  label: Scalars['String']['output'];
  options: Array<Shop_SearchCategoryOption>;
  type: Scalars['String']['output'];
};

export type Shop_SearchCategoryOption = {
  __typename?: 'shop_SearchCategoryOption';
  applied: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<Shop_SearchCategoryOption>>>;
  url: Scalars['String']['output'];
};

export type Shop_SearchContext = {
  __typename?: 'shop_SearchContext';
  category?: Maybe<Scalars['String']['output']>;
};

export type Shop_SearchContextInput = {
  category: Scalars['String']['input'];
  query: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type Shop_SearchFilter = {
  __typename?: 'shop_SearchFilter';
  appliedCount: Scalars['Int']['output'];
  appliedPath: Array<Maybe<Scalars['String']['output']>>;
  filters: Array<Shop_SearchFilterGroup>;
  resetUrl: Scalars['String']['output'];
  resets: Array<Maybe<Shop_SearchFilterResets>>;
  staticFilters: Array<Shop_SearchCategoryGroup>;
};

export type Shop_SearchFilterGroup = {
  __typename?: 'shop_SearchFilterGroup';
  experiences: Array<Shop_Attribute>;
  label: Scalars['String']['output'];
  options: Array<Shop_SearchFilterGroupOption>;
  resetLabel?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Shop_SearchFilterGroupOption = {
  __typename?: 'shop_SearchFilterGroupOption';
  applied: Scalars['Boolean']['output'];
  disabled: Scalars['Boolean']['output'];
  hexColor?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Shop_SearchFilterResets = {
  __typename?: 'shop_SearchFilterResets';
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Shop_SearchResult = {
  __typename?: 'shop_SearchResult';
  artistIsEstablished: Scalars['Boolean']['output'];
  defaultPreviewTypeId?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  inventoryItem?: Maybe<Shop_Inventory_InventoryItemsItem>;
  inventoryItemId: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  work?: Maybe<Shop_SearchResultWork>;
  workId: Scalars['String']['output'];
};


export type Shop_SearchResultInventoryItemArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type Shop_SearchResultWorkArgs = {
  locale: Scalars['String']['input'];
};

export type Shop_SearchResultRelatedProduct = {
  __typename?: 'shop_SearchResultRelatedProduct';
  fullTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  productTitle: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Shop_SearchResultTopic = {
  __typename?: 'shop_SearchResultTopic';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Shop_SearchResultWork = {
  __typename?: 'shop_SearchResultWork';
  artistName: Scalars['String']['output'];
  artistShopDisplayName: Scalars['String']['output'];
  artistUserName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isMatureContent: Scalars['Boolean']['output'];
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Shop_SearchResults = {
  __typename?: 'shop_SearchResults';
  artistCollections?: Maybe<Shop_ArtistCollections>;
  blockedTerm: Scalars['Boolean']['output'];
  filters?: Maybe<Shop_SearchFilter>;
  metadata?: Maybe<Shop_SearchResultsMetadata>;
  pagination?: Maybe<Shop_Pagination>;
  results: Array<Shop_SearchResult>;
  /** @deprecated trendingResults is no longer used and will only return an empty array */
  trendingResults: Array<Shop_SearchResult>;
};

export type Shop_SearchResultsBar = {
  __typename?: 'shop_SearchResultsBar';
  iaCode?: Maybe<Scalars['String']['output']>;
  keywords: Array<Scalars['String']['output']>;
  pillLabel?: Maybe<Scalars['String']['output']>;
};

export type Shop_SearchResultsMetadata = {
  __typename?: 'shop_SearchResultsMetadata';
  formattedQuery: Scalars['String']['output'];
  landingPage: Shop_ShopLandingPageData;
  relatedProducts: Array<Shop_SearchResultRelatedProduct>;
  relatedTopics: Array<Maybe<Shop_SearchResultTopic>>;
  resultCount: Scalars['Int']['output'];
  searchBar?: Maybe<Shop_SearchResultsBar>;
  searchContext: Shop_SearchContext;
  searchPageType: Scalars['String']['output'];
  searchUUID: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Scalars['String']['output']>;
};

export type Shop_SearchResultsSeoMetadata = {
  __typename?: 'shop_SearchResultsSEOMetadata';
  alternatePageVersions: Array<Maybe<Shop_AlternatePageVersion>>;
  canonicalURL?: Maybe<Scalars['String']['output']>;
  faq?: Maybe<Shop_LandingPageFaq>;
  id: Scalars['ID']['output'];
  pageDescription: Scalars['String']['output'];
  relatedTagLinks: Array<Maybe<Shop_SeoMetadataRelatedTagLink>>;
  robots?: Maybe<Scalars['String']['output']>;
  searchTitle: Scalars['String']['output'];
  seoImage?: Maybe<Scalars['String']['output']>;
};

export type Shop_SearchSortOrder = {
  __typename?: 'shop_SearchSortOrder';
  code?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  selected?: Maybe<Scalars['Boolean']['output']>;
  url: Scalars['String']['output'];
};

export type Shop_SearchType = {
  __typename?: 'shop_SearchType';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Shop_SessionContext = {
  __typename?: 'shop_SessionContext';
  features: Array<Scalars['String']['output']>;
  isBot: Scalars['Boolean']['output'];
};

export type Shop_ShopBubble = {
  __typename?: 'shop_ShopBubble';
  image?: Maybe<Scalars['String']['output']>;
  isExternal?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  realisticImage?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Shop_ShopFilterItem = {
  __typename?: 'shop_ShopFilterItem';
  filterItemId: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  items?: Maybe<Array<Maybe<Shop_ShopFilterSubItem>>>;
  name: Scalars['String']['output'];
  open?: Maybe<Scalars['Boolean']['output']>;
  reveal?: Maybe<Shop_ShopFilterItemReveal>;
  selected?: Maybe<Scalars['String']['output']>;
};

export type Shop_ShopFilterItemReveal = {
  __typename?: 'shop_ShopFilterItemReveal';
  count?: Maybe<Scalars['Int']['output']>;
  hidden: Scalars['Boolean']['output'];
  less?: Maybe<Scalars['String']['output']>;
  more?: Maybe<Scalars['String']['output']>;
};

export type Shop_ShopFilterSubItem = {
  __typename?: 'shop_ShopFilterSubItem';
  active: Scalars['Boolean']['output'];
  dataUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nofollow?: Maybe<Scalars['Boolean']['output']>;
  secondary?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Shop_ShopLandingPageBubbles = {
  __typename?: 'shop_ShopLandingPageBubbles';
  hasImages: Scalars['Boolean']['output'];
  items: Array<Shop_ShopBubble>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Shop_ShopLandingPageData = {
  __typename?: 'shop_ShopLandingPageData';
  bubbles?: Maybe<Shop_ShopLandingPageBubbles>;
  footer?: Maybe<Shop_ShopLandingPageFooter>;
  hero?: Maybe<Shop_ShopLandingPageHero>;
  hideSearchFilter?: Maybe<Scalars['Boolean']['output']>;
  seoMetadata: Shop_SearchResultsSeoMetadata;
};

export type Shop_ShopLandingPageFooter = {
  __typename?: 'shop_ShopLandingPageFooter';
  breadcrumbs?: Maybe<Array<Shop_Breadcrumb>>;
  readMoreText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Shop_ShopLandingPageHero = {
  __typename?: 'shop_ShopLandingPageHero';
  color?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  pitch?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Shop_UsBusinessInfo = {
  __typename?: 'shop_UsBusinessInfo';
  businessAddress?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessPhoneNumber?: Maybe<Scalars['String']['output']>;
  shouldDisplayInformation: Scalars['Boolean']['output'];
};

export type Shop_UserAccount = {
  __typename?: 'shop_UserAccount';
  analytics?: Maybe<Shop_UserAccountAnalytics>;
  displayName?: Maybe<Scalars['String']['output']>;
  favoritesList?: Maybe<Shop_List>;
  followedIds?: Maybe<Array<Scalars['Int']['output']>>;
  hasAvatar: Scalars['Boolean']['output'];
  homepage: Scalars['String']['output'];
  isArtist: Scalars['Boolean']['output'];
  joinedAt: Scalars['shop_DateTime']['output'];
  metrics?: Maybe<Shop_UserAccountMetrics>;
  onboardedAt?: Maybe<Scalars['shop_DateTime']['output']>;
};


export type Shop_UserAccountFollowedIdsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Shop_UserAccountAnalytics = {
  __typename?: 'shop_UserAccountAnalytics';
  artistSalesGroup: Scalars['String']['output'];
  artistUploadsGroup: Scalars['String']['output'];
};

export type Shop_UserAccountMetrics = {
  __typename?: 'shop_UserAccountMetrics';
  favorites: Scalars['Int']['output'];
  followers: Scalars['Int']['output'];
  productsSold: Scalars['Int']['output'];
};

export type Shop_UserEventInput = {
  message: Shop_UserEventMessageInput;
  name: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export type Shop_UserEventMessageInput = {
  inventoryItemId?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  workId: Scalars['ID']['input'];
};

export type Shop_UserInfo = {
  __typename?: 'shop_UserInfo';
  avatar?: Maybe<Scalars['String']['output']>;
  cartItems?: Maybe<Scalars['Int']['output']>;
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  enrolments: Array<Shop_Enrolment>;
  federatedId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEligibleForAutoSubscribe: Scalars['Boolean']['output'];
  isLoggedIn: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  showMatureContent: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type Shop_WorkImage = {
  __typename?: 'shop_WorkImage';
  previewUrl?: Maybe<Scalars['String']['output']>;
  workId?: Maybe<Scalars['String']['output']>;
};

export type Shop_ArtistDomain_FollowedArtist = {
  __typename?: 'shop_artistDomain_FollowedArtist';
  artistId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isFollowed: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type Shop_ArtistDomain_FollowedArtistEdge = {
  __typename?: 'shop_artistDomain_FollowedArtistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Shop_ArtistDomain_FollowedArtist>;
};

/** The connection type for FollowedArtist. */
export type Shop_ArtistDomain_FollowedArtistTypeConnection = {
  __typename?: 'shop_artistDomain_FollowedArtistTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Shop_ArtistDomain_FollowedArtistEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Shop_ArtistDomain_FollowedArtist>>>;
  /** Information to aid in pagination. */
  pageInfo: Shop_ArtistDomain_PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Information about pagination in a connection. */
export type Shop_ArtistDomain_PageInfo = {
  __typename?: 'shop_artistDomain_PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Shop_Cart_Cart = {
  __typename?: 'shop_cart_Cart';
  id: Scalars['ID']['output'];
  items: Array<Shop_Cart_Item>;
  totalItems: Scalars['Int']['output'];
};

export type Shop_Cart_Item = {
  __typename?: 'shop_cart_Item';
  id: Scalars['ID']['output'];
  inventoryItemId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
};

export type Shop_Cart_SailthruIds = {
  /** Campaign attribution ID */
  bid?: InputMaybe<Scalars['String']['input']>;
  /** Sailthru User ID */
  hid: Scalars['String']['input'];
};

export type Shop_Comments_Comment = {
  __typename?: 'shop_comments_Comment';
  active: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canReply: Scalars['Boolean']['output'];
  canReport: Scalars['Boolean']['output'];
  comment: Scalars['String']['output'];
  commentReplies: Array<Shop_Comments_Comment>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  user: Shop_Comments_User;
  userId: Scalars['String']['output'];
  workId: Scalars['String']['output'];
};

export type Shop_Comments_User = {
  __typename?: 'shop_comments_User';
  avatar?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export enum Shop_Guru_Activity {
  ProductView = 'PRODUCT_VIEW',
  WorkView = 'WORK_VIEW'
}

export type Shop_Guru_ArtistRecommendation = {
  __typename?: 'shop_guru_ArtistRecommendation';
  recommendedArtistId: Scalars['Int']['output'];
  recommendedWorkId: Scalars['Int']['output'];
  seedWorkId: Scalars['Int']['output'];
  works: Array<Shop_Guru_WorkRecommendation>;
};

export enum Shop_Guru_ArtistRecommendationMethod {
  AlsMatrixArtist = 'alsMatrixArtist',
  Default = 'default'
}

export type Shop_Guru_ArtistRecommendations = {
  __typename?: 'shop_guru_ArtistRecommendations';
  recommendations: Array<Shop_Guru_ArtistRecommendation>;
};

export enum Shop_Guru_Experience {
  Explore = 'explore',
  Feed = 'feed'
}

export type Shop_Guru_InventoryItemRecommendation = {
  __typename?: 'shop_guru_InventoryItemRecommendation';
  inventoryItem?: Maybe<Shop_Inventory_InventoryItemsItem>;
  inventoryItemId: Scalars['String']['output'];
  workId: Scalars['String']['output'];
};


export type Shop_Guru_InventoryItemRecommendationInventoryItemArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  unit?: InputMaybe<Shop_Inventory_Unit>;
};

export type Shop_Guru_InventoryItemRecommendations = {
  __typename?: 'shop_guru_InventoryItemRecommendations';
  createdAt: Scalars['shop_guru_Date']['output'];
  id: Scalars['ID']['output'];
  recommendations: Array<Shop_Guru_InventoryItemRecommendation>;
};

export enum Shop_Guru_ListEntity {
  InventoryItem = 'INVENTORY_ITEM',
  Work = 'WORK'
}

export type Shop_Guru_ListInputItem = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType: Shop_Guru_ListEntity;
};

export type Shop_Guru_ListInventoryItemRecommendation = Shop_Guru_ListItemRecommendation & {
  __typename?: 'shop_guru_ListInventoryItemRecommendation';
  entityId: Scalars['String']['output'];
  entityType: Shop_Guru_ListEntity;
  inventoryItem?: Maybe<Shop_Inventory_InventoryItemsItem>;
};


export type Shop_Guru_ListInventoryItemRecommendationInventoryItemArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  unit?: InputMaybe<Shop_Inventory_Unit>;
};

export type Shop_Guru_ListItemRecommendation = {
  entityId: Scalars['String']['output'];
  entityType: Shop_Guru_ListEntity;
};

export type Shop_Guru_ListItemRecommendations = {
  __typename?: 'shop_guru_ListItemRecommendations';
  recommendations: Array<Shop_Guru_ListItemRecommendation>;
};

export type Shop_Guru_ListWorkRecommendation = Shop_Guru_ListItemRecommendation & {
  __typename?: 'shop_guru_ListWorkRecommendation';
  entityId: Scalars['String']['output'];
  entityType: Shop_Guru_ListEntity;
};

export enum Shop_Guru_Locale {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr'
}

export type Shop_Guru_RecentActivity = {
  __typename?: 'shop_guru_RecentActivity';
  views: Array<Shop_Guru_ViewActivityItem>;
};

export enum Shop_Guru_RelatedWorksMethod {
  Default = 'default',
  SimilarDesigns = 'similarDesigns'
}

export type Shop_Guru_TopicProductList = {
  __typename?: 'shop_guru_TopicProductList';
  iaCode: Scalars['String']['output'];
  items: Array<Shop_Guru_InventoryItemRecommendation>;
  topic: Scalars['String']['output'];
};

export type Shop_Guru_TopicProductLists = {
  __typename?: 'shop_guru_TopicProductLists';
  createdAt: Scalars['shop_guru_Date']['output'];
  recommendations: Array<Shop_Guru_TopicProductList>;
};

export type Shop_Guru_TopicRecommendation = {
  __typename?: 'shop_guru_TopicRecommendation';
  topic: Scalars['String']['output'];
  workRecommendations: Array<Shop_Guru_WorkRecommendation>;
};

export type Shop_Guru_TopicRecommendations = {
  __typename?: 'shop_guru_TopicRecommendations';
  recommendations: Array<Shop_Guru_TopicRecommendation>;
};

export type Shop_Guru_ViewActivityItem = {
  __typename?: 'shop_guru_ViewActivityItem';
  inventoryItemId?: Maybe<Scalars['String']['output']>;
  workId: Scalars['String']['output'];
};

export type Shop_Guru_WorkRecommendation = {
  __typename?: 'shop_guru_WorkRecommendation';
  workId: Scalars['String']['output'];
};

export enum Shop_Guru_WorkRecommendationMethod {
  Coviews = 'coviews',
  Default = 'default',
  FoundFeedBackoff = 'foundFeedBackoff',
  GuruBackoff = 'guruBackoff'
}

export type Shop_Guru_WorkRecommendations = {
  __typename?: 'shop_guru_WorkRecommendations';
  canId?: Maybe<Scalars['String']['output']>;
  canSize: Scalars['Int']['output'];
  createdAt: Scalars['shop_guru_Date']['output'];
  recommendations: Array<Shop_Guru_WorkRecommendation>;
};

/** Generic nested key value type */
export type Shop_Inventory_Attribute = {
  __typename?: 'shop_inventory_Attribute';
  attributes: Array<Shop_Inventory_Attribute>;
  name: Scalars['String']['output'];
  value: Scalars['shop_inventory_Any']['output'];
};

/** Catalogue of inventory items and available configuration options */
export type Shop_Inventory_CategorySet = {
  __typename?: 'shop_inventory_CategorySet';
  categoryName: Scalars['String']['output'];
  configurationSet: Array<Shop_Inventory_Attribute>;
  defaultItem: Shop_Inventory_ProductSetItem;
  defaultItems: Array<Shop_Inventory_ProductSetItem>;
  id: Scalars['ID']['output'];
  items: Array<Shop_Inventory_ProductSetItem>;
  work: Shop_Inventory_Work;
};


/** Catalogue of inventory items and available configuration options */
export type Shop_Inventory_CategorySetWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** A size guide table */
export type Shop_Inventory_DimensionGuide = {
  __typename?: 'shop_inventory_DimensionGuide';
  columns: Array<Shop_Inventory_Attribute>;
  fixedFirstColumn: Scalars['Boolean']['output'];
  rows: Array<Shop_Inventory_Attribute>;
};

/** Product dimensions */
export type Shop_Inventory_Dimensions = {
  __typename?: 'shop_inventory_Dimensions';
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  unit: Shop_Inventory_Unit;
  width: Scalars['Float']['output'];
};

export type Shop_Inventory_InStockStatus = Shop_Inventory_StockStatus & {
  __typename?: 'shop_inventory_InStockStatus';
  /** Always 'in-stock' */
  status: Scalars['String']['output'];
};

/** A single inventory item */
export type Shop_Inventory_InventoryItem = {
  __typename?: 'shop_inventory_InventoryItem';
  attributes: Array<Shop_Inventory_Attribute>;
  blankItemId: Scalars['String']['output'];
  categoryId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  experiences: Array<Shop_Attribute>;
  features: Array<Scalars['String']['output']>;
  gaCategory?: Maybe<Scalars['String']['output']>;
  gaCode?: Maybe<Scalars['String']['output']>;
  hasSizeGuide: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Intended for use as a longer-form description in the style selector on mobile and the web.
   * For example: 'Super soft tee, crew neck, regular fit'.
   */
  longStyleDescription: Scalars['String']['output'];
  path: Scalars['String']['output'];
  preview?: Maybe<Shop_Inventory_Preview>;
  previewSet?: Maybe<Shop_Inventory_PreviewSet>;
  price?: Maybe<Shop_Inventory_Price>;
  /** @deprecated Use InventoryItem.features */
  productInfo: Shop_Inventory_ProductInfo;
  productPageUrl?: Maybe<Scalars['String']['output']>;
  productPageUrls?: Maybe<Shop_Inventory_ProductUrl>;
  productTypeId: Scalars['String']['output'];
  seoProductCategory?: Maybe<Scalars['String']['output']>;
  /**
   * stockStatus will always be "in stock" if country is not passed. This is for
   * backward compatibility reasons: clients that are not yet configured to send
   * the shipping country can't suddenly find everything is out of stock.
   */
  stockStatus: Shop_Inventory_StockStatus;
  volumeDiscount?: Maybe<Shop_Inventory_VolumeDiscount>;
  work: Shop_Inventory_Work;
  workId: Scalars['Int']['output'];
};


/** A single inventory item */
export type Shop_Inventory_InventoryItemPreviewArgs = {
  previewTypeId?: InputMaybe<Scalars['String']['input']>;
};


/** A single inventory item */
export type Shop_Inventory_InventoryItemPreviewSetArgs = {
  previewTypeIds: Array<Scalars['String']['input']>;
};


/** A single inventory item */
export type Shop_Inventory_InventoryItemPriceArgs = {
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
};


/** A single inventory item */
export type Shop_Inventory_InventoryItemProductPageUrlArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
};


/** A single inventory item */
export type Shop_Inventory_InventoryItemProductPageUrlsArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
};


/** A single inventory item */
export type Shop_Inventory_InventoryItemWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A single inventory item contained within a collection.
 * See InventoryItem for more detailed field descriptions.
 */
export type Shop_Inventory_InventoryItemsItem = {
  __typename?: 'shop_inventory_InventoryItemsItem';
  attributes: Array<Shop_Inventory_Attribute>;
  blankItemId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  experiencesProductCard: Array<Shop_Attribute>;
  features: Array<Scalars['String']['output']>;
  gaCategory?: Maybe<Scalars['String']['output']>;
  gaCode?: Maybe<Scalars['String']['output']>;
  hasSizeGuide: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lists?: Maybe<Shop_Lists_Inclusion>;
  longStyleDescription: Scalars['String']['output'];
  marketingProductTypeId?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Shop_Inventory_Preview>;
  previewSet?: Maybe<Shop_Inventory_PreviewSet>;
  price?: Maybe<Shop_Inventory_Price>;
  /** @deprecated Use InventoryItemsItem.features */
  productInfo: Shop_Inventory_ProductInfo;
  /**
   * productPageUrl is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'ProductUrl.url' field.
   */
  productPageUrl?: Maybe<Scalars['String']['output']>;
  productPageUrls?: Maybe<Shop_Inventory_ProductUrl>;
  productTypeId: Scalars['String']['output'];
  prominentMessage?: Maybe<Scalars['String']['output']>;
  seoProductCategory?: Maybe<Scalars['String']['output']>;
  /** See InventoryItem.stockStatus for caveats */
  stockStatus: Shop_Inventory_StockStatus;
  volumeDiscount?: Maybe<Shop_Inventory_VolumeDiscount>;
  work: Shop_Inventory_Work;
  workId: Scalars['Int']['output'];
};


/**
 * A single inventory item contained within a collection.
 * See InventoryItem for more detailed field descriptions.
 */
export type Shop_Inventory_InventoryItemsItemPreviewArgs = {
  previewTypeId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A single inventory item contained within a collection.
 * See InventoryItem for more detailed field descriptions.
 */
export type Shop_Inventory_InventoryItemsItemWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type Shop_Inventory_NoopEntityToWorkAroundFederationBug = {
  __typename?: 'shop_inventory_NoopEntityToWorkAroundFederationBug';
  id: Scalars['ID']['output'];
};

export type Shop_Inventory_OutOfStockStatus = Shop_Inventory_StockStatus & {
  __typename?: 'shop_inventory_OutOfStockStatus';
  /** Always 'out-of-stock' */
  status: Scalars['String']['output'];
};

export type Shop_Inventory_PresaleStockStatus = Shop_Inventory_StockStatus & {
  __typename?: 'shop_inventory_PresaleStockStatus';
  /** Always 'presale' */
  status: Scalars['String']['output'];
};

/** A preview with its preview type ID and Magickraum URL */
export type Shop_Inventory_Preview = {
  __typename?: 'shop_inventory_Preview';
  /**
   * All available formats for this preview (image/jpeg, image/webp). There
   *   should be one and only one format marked as default. The default format in
   *   this list will also be available as 'url' and 'mime' in the Preview type.
   */
  formats: Array<Shop_Inventory_PreviewFormat>;
  id: Scalars['ID']['output'];
  /** Mime type of the fallback format from formats */
  mime: Scalars['String']['output'];
  previewTypeId: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  /** URL of the fallback format from formats */
  url: Scalars['String']['output'];
};

export type Shop_Inventory_PreviewFormat = {
  __typename?: 'shop_inventory_PreviewFormat';
  fallback: Scalars['Boolean']['output'];
  mime: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A wrapper for one or more Previews to annotate with inventory item id */
export type Shop_Inventory_PreviewItem = {
  __typename?: 'shop_inventory_PreviewItem';
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['ID']['output'];
  item: Array<Shop_Inventory_Preview>;
};

/** Set of previews with urls */
export type Shop_Inventory_PreviewSet = {
  __typename?: 'shop_inventory_PreviewSet';
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['ID']['output'];
  previews: Array<Shop_Inventory_Preview>;
};

/** Represents a price with currency */
export type Shop_Inventory_Price = {
  __typename?: 'shop_inventory_Price';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  discount: Shop_Inventory_PromoDiscount;
  id: Scalars['ID']['output'];
};

/** Wrapper type for product description */
export type Shop_Inventory_ProductInfo = {
  __typename?: 'shop_inventory_ProductInfo';
  /** @deprecated Use features in InventoryItem, InventoryItemsItem or ProductSetItem */
  longDescription: Array<Scalars['String']['output']>;
};

export type Shop_Inventory_ProductPageUrls = {
  __typename?: 'shop_inventory_ProductPageUrls';
  /**
   * fallbackUrl is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'ProductUrl.url' field.
   */
  fallbackUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * url is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'ProductUrl.url' field.
   */
  url?: Maybe<Scalars['String']['output']>;
};

/** A single inventory item contained within a CategorySet */
export type Shop_Inventory_ProductSetItem = {
  __typename?: 'shop_inventory_ProductSetItem';
  attributes: Array<Shop_Inventory_Attribute>;
  blankItemId: Scalars['String']['output'];
  categoryId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  experiences: Array<Shop_Attribute>;
  features: Array<Scalars['String']['output']>;
  gaCategory?: Maybe<Scalars['String']['output']>;
  gaCode?: Maybe<Scalars['String']['output']>;
  hasSizeGuide: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  longStyleDescription: Scalars['String']['output'];
  marketingProductTypeId?: Maybe<Scalars['String']['output']>;
  measurementSummary?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  preview?: Maybe<Shop_Inventory_Preview>;
  previewSet?: Maybe<Shop_Inventory_PreviewSet>;
  price?: Maybe<Shop_Inventory_Price>;
  /** @deprecated Use ProductSetItem.features */
  productInfo: Shop_Inventory_ProductInfo;
  /**
   * productPageUrl is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'ProductUrl.url' field.
   */
  productPageUrl?: Maybe<Scalars['String']['output']>;
  productPageUrls?: Maybe<Shop_Inventory_ProductPageUrls>;
  productTypeId: Scalars['String']['output'];
  prominentMessage?: Maybe<Scalars['String']['output']>;
  seoProductCategory?: Maybe<Scalars['String']['output']>;
  /** See InventoryItem.stockStatus for caveats */
  stockStatus: Shop_Inventory_StockStatus;
  tagCloudIaCode?: Maybe<Scalars['String']['output']>;
  volumeDiscount?: Maybe<Shop_Inventory_VolumeDiscount>;
  work: Shop_Inventory_Work;
  workId: Scalars['Int']['output'];
};


/** A single inventory item contained within a CategorySet */
export type Shop_Inventory_ProductSetItemPreviewArgs = {
  previewTypeId?: InputMaybe<Scalars['String']['input']>;
};


/** A single inventory item contained within a CategorySet */
export type Shop_Inventory_ProductSetItemWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** A Product URL */
export type Shop_Inventory_ProductUrl = {
  __typename?: 'shop_inventory_ProductUrl';
  /**
   * fallbackUrl is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'url' field.
   */
  fallbackUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * url is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients EXCEPT under the following circumstances:
   *
   * - To add (but not remove or modify) query string parameters
   * - To add a fragment _iff_ the client knows itself to be the target of the URL AND
   *   there is no fragment already
   * - To modify the authority _iff_ the client knows itself to be the target of the URL
   *   (this would likely be envronment specific, and this rule is mostly intended for
   *   facilitating local development)
   *
   * All other parts of the URL, in all other circumstances, should be left exactly as
   * they are received.
   */
  url?: Maybe<Scalars['String']['output']>;
};

/** A wrapper for one or more Product URLs to annotate with inventory item id */
export type Shop_Inventory_ProductUrlItem = {
  __typename?: 'shop_inventory_ProductUrlItem';
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['String']['output'];
  item: Shop_Inventory_ProductUrl;
  locale?: Maybe<Scalars['String']['output']>;
};

/** Represents a promotional discount of a price */
export type Shop_Inventory_PromoDiscount = {
  __typename?: 'shop_inventory_PromoDiscount';
  amount: Scalars['Float']['output'];
  percent: Scalars['Float']['output'];
};

/**
 * XXX 20250805: We are leaving space for individual stock statuses to have their own
 * sets of fields. This is not in use at the time of writing, but we want to make sure
 * the option is available. Consuming systems MUST NOT close this door. Fields may be
 * added at the interface level, or the type level.
 */
export type Shop_Inventory_StockStatus = {
  status: Scalars['String']['output'];
};

export enum Shop_Inventory_Unit {
  Cm = 'CM',
  In = 'IN'
}

export type Shop_Inventory_VolumeDiscount = {
  __typename?: 'shop_inventory_VolumeDiscount';
  id: Scalars['ID']['output'];
  thresholds: Array<Shop_Inventory_VolumeDiscountThreshold>;
};

export type Shop_Inventory_VolumeDiscountThreshold = {
  __typename?: 'shop_inventory_VolumeDiscountThreshold';
  percentOff: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type Shop_Inventory_Work = {
  __typename?: 'shop_inventory_Work';
  artist?: Maybe<Shop_Artist>;
  artistDisplayName: Scalars['String']['output'];
  artistShopDisplayName?: Maybe<Scalars['String']['output']>;
  artistUsername: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use workId */
  id: Scalars['ID']['output'];
  isMachineTranslated: Scalars['Boolean']['output'];
  licensed: Scalars['Boolean']['output'];
  linkBackTags: Array<Scalars['String']['output']>;
  lists?: Maybe<Shop_Lists_Inclusion>;
  matureContent: Scalars['Boolean']['output'];
  originalLocale?: Maybe<Scalars['String']['output']>;
  portfolioPreview?: Maybe<Shop_Inventory_Preview>;
  productPageIndexable: Scalars['Boolean']['output'];
  /**
   * remoteKey contains the imagehaus image ID for either the :print image type, or
   *   a fallback image type. It has been used for constructing certain previews in the
   *   past, but see the deprecation notice for more details and please do not use it in
   *   future.
   * @deprecated This should not be used, especially not for constructing magickraum URLs by
   * hand; the Preview Reference API contained herein should perform that role. If
   * it does not satisfy a particular use case or it is not available at the point
   * in the graph you require, instead of using this, please reach out.
   */
  remoteKey?: Maybe<Scalars['String']['output']>;
  /** 'tags' is deprecated; use tagsOriginal or tagsCleaned */
  tags: Array<Scalars['String']['output']>;
  /** 'tagsCleaned' contains normalised tags, stripped of product synonyms */
  tagsCleaned: Array<Scalars['String']['output']>;
  /** 'tagsOriginal' contains the exact unmodified tags array we received from the monolith */
  tagsOriginal: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  workId: Scalars['Int']['output'];
};

export type Shop_Inventory__Entity = Shop_Inventory_NoopEntityToWorkAroundFederationBug;

export type Shop_Inventory__Service = {
  __typename?: 'shop_inventory__Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type Shop_Lists_Action = {
  __typename?: 'shop_lists_Action';
  delete: Scalars['Boolean']['output'];
  editName: Scalars['Boolean']['output'];
  editPrivacy: Scalars['Boolean']['output'];
};

export type Shop_Lists_AddItemToDefaultListInput = {
  item: Shop_Lists_ItemInput;
  locale: Scalars['String']['input'];
};

export type Shop_Lists_AddItemToDefaultListPayload = {
  __typename?: 'shop_lists_AddItemToDefaultListPayload';
  defaultList?: Maybe<Shop_Lists_List>;
  inclusions?: Maybe<Shop_Lists_Inclusion>;
};

export type Shop_Lists_AddItemToListInput = {
  item: Shop_Lists_ItemInput;
  listId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export type Shop_Lists_AddItemToListPayload = {
  __typename?: 'shop_lists_AddItemToListPayload';
  defaultList?: Maybe<Shop_Lists_List>;
  inclusions?: Maybe<Shop_Lists_Inclusion>;
};

export type Shop_Lists_CreateListInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  privacy?: InputMaybe<Shop_Lists_PrivacyValue>;
};

export type Shop_Lists_CreateListPayload = {
  __typename?: 'shop_lists_CreateListPayload';
  list?: Maybe<Shop_Lists_List>;
};

export type Shop_Lists_DeleteListInput = {
  listId: Scalars['ID']['input'];
};

export enum Shop_Lists_Entity {
  InventoryItem = 'INVENTORY_ITEM',
  Work = 'WORK'
}

export type Shop_Lists_Favorite = {
  id: Scalars['ID']['output'];
  isFavorited: Scalars['Boolean']['output'];
};

export type Shop_Lists_FavoriteConnection = {
  __typename?: 'shop_lists_FavoriteConnection';
  edges?: Maybe<Array<Maybe<Shop_Lists_FavoriteEdge>>>;
  pageInfo: Shop_Lists_PageInfo;
  /** The total number of items available. */
  totalCount: Scalars['Int']['output'];
};

export type Shop_Lists_FavoriteEdge = {
  __typename?: 'shop_lists_FavoriteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Shop_Lists_Favorite>;
};

export type Shop_Lists_FavoriteInput = {
  inventoryItemId?: InputMaybe<Scalars['String']['input']>;
  workId?: InputMaybe<Scalars['ID']['input']>;
};

export type Shop_Lists_FavoriteStatus = {
  __typename?: 'shop_lists_FavoriteStatus';
  id: Scalars['ID']['output'];
  isFavorited: Scalars['Boolean']['output'];
  item: Shop_Lists_Favorite;
};

export type Shop_Lists_FavoritesInput = {
  inventoryItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  workIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Shop_Lists_FavoritesListInput = {
  locale: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Shop_Lists_Inclusion = {
  __typename?: 'shop_lists_Inclusion';
  id: Scalars['ID']['output'];
  item?: Maybe<Shop_Lists_Item>;
  lists?: Maybe<Array<Shop_Lists_ListId>>;
};

export type Shop_Lists_InclusionsInput = {
  items?: InputMaybe<Array<Shop_Lists_ItemInput>>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type Shop_Lists_InventoryItem = {
  __typename?: 'shop_lists_InventoryItem';
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['String']['output'];
  isFavorited: Scalars['Boolean']['output'];
};

export type Shop_Lists_InventoryItemFavorite = Shop_Lists_Favorite & {
  __typename?: 'shop_lists_InventoryItemFavorite';
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['String']['output'];
  isFavorited: Scalars['Boolean']['output'];
};

export type Shop_Lists_InventoryItemItem = Shop_Lists_Item & {
  __typename?: 'shop_lists_InventoryItemItem';
  entityId: Scalars['String']['output'];
  entityType: Shop_Lists_Entity;
  id: Scalars['ID']['output'];
  inventoryItem?: Maybe<Shop_Inventory_InventoryItemsItem>;
};


export type Shop_Lists_InventoryItemItemInventoryItemArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  unit?: InputMaybe<Shop_Inventory_Unit>;
};

export type Shop_Lists_Item = {
  entityId: Scalars['String']['output'];
  entityType: Shop_Lists_Entity;
  id: Scalars['ID']['output'];
};

/** The connection type for Item. */
export type Shop_Lists_ItemConnection = {
  __typename?: 'shop_lists_ItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Shop_Lists_ItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Shop_Lists_Item>>>;
  /** Information to aid in pagination. */
  pageInfo: Shop_Lists_PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Shop_Lists_ItemEdge = {
  __typename?: 'shop_lists_ItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Shop_Lists_Item>;
};

export type Shop_Lists_ItemInput = {
  entityId: Scalars['String']['input'];
  entityType: Shop_Lists_Entity;
};

export type Shop_Lists_List = {
  __typename?: 'shop_lists_List';
  actions: Shop_Lists_Action;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Shop_Lists_ItemConnection>;
  listId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  privacy: Shop_Lists_Privacy;
};


export type Shop_Lists_ListItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for List. */
export type Shop_Lists_ListConnection = {
  __typename?: 'shop_lists_ListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Shop_Lists_ListEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Shop_Lists_List>>>;
  /** Information to aid in pagination. */
  pageInfo: Shop_Lists_PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Shop_Lists_ListEdge = {
  __typename?: 'shop_lists_ListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Shop_Lists_List>;
};

export type Shop_Lists_ListId = {
  __typename?: 'shop_lists_ListId';
  id: Scalars['ID']['output'];
  listId: Scalars['String']['output'];
};

export type Shop_Lists_ListInput = {
  listId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export type Shop_Lists_Lists = {
  __typename?: 'shop_lists_Lists';
  defaultList?: Maybe<Shop_Lists_List>;
  id: Scalars['ID']['output'];
  lists?: Maybe<Shop_Lists_ListConnection>;
};


export type Shop_Lists_ListsListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Shop_Lists_ListsInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Information about pagination in a connection. */
export type Shop_Lists_PageInfo = {
  __typename?: 'shop_lists_PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Shop_Lists_Privacy = {
  __typename?: 'shop_lists_Privacy';
  description: Scalars['String']['output'];
  value: Shop_Lists_PrivacyValue;
};

export enum Shop_Lists_PrivacyValue {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Shop_Lists_RemoveItemFromListInput = {
  item: Shop_Lists_ItemInput;
  listId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export type Shop_Lists_RemoveItemFromListPayload = {
  __typename?: 'shop_lists_RemoveItemFromListPayload';
  defaultList?: Maybe<Shop_Lists_List>;
  inclusions?: Maybe<Shop_Lists_Inclusion>;
};

export type Shop_Lists_UpdateListInput = {
  listId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Shop_Lists_UpdateListPayload = {
  __typename?: 'shop_lists_UpdateListPayload';
  list?: Maybe<Shop_Lists_List>;
};

export type Shop_Lists_WorkFavorite = Shop_Lists_Favorite & {
  __typename?: 'shop_lists_WorkFavorite';
  id: Scalars['ID']['output'];
  isFavorited: Scalars['Boolean']['output'];
  workId: Scalars['String']['output'];
};

export type Shop_Lists_WorkItem = Shop_Lists_Item & {
  __typename?: 'shop_lists_WorkItem';
  entityId: Scalars['String']['output'];
  entityType: Shop_Lists_Entity;
  id: Scalars['ID']['output'];
  work?: Maybe<Shop_Inventory_Work>;
};


export type Shop_Lists_WorkItemWorkArgs = {
  locale: Scalars['String']['input'];
};

export type Shop_OrderHistory_Action = {
  __typename?: 'shop_orderHistory_Action';
  cancelForRefund: Scalars['Boolean']['output'];
};

export type Shop_OrderHistory_Address = {
  __typename?: 'shop_orderHistory_Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Shop_OrderHistory_Country>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
};

export type Shop_OrderHistory_Country = {
  __typename?: 'shop_orderHistory_Country';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Shop_OrderHistory_EstimatedDeliveryDates = {
  __typename?: 'shop_orderHistory_EstimatedDeliveryDates';
  highTimestamp?: Maybe<Scalars['shop_orderHistory_ISO8601DateTime']['output']>;
  isLastOrderBy: Scalars['Boolean']['output'];
  lowTimestamp?: Maybe<Scalars['shop_orderHistory_ISO8601DateTime']['output']>;
};

export type Shop_OrderHistory_FoundOrder = {
  __typename?: 'shop_orderHistory_FoundOrder';
  purchaseOrderDetailsPath: Scalars['String']['output'];
};

export type Shop_OrderHistory_Gift = {
  __typename?: 'shop_orderHistory_Gift';
  emailAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
};

export type Shop_OrderHistory_GiftOrder = {
  __typename?: 'shop_orderHistory_GiftOrder';
  estimatedDeliveryDate?: Maybe<Scalars['String']['output']>;
  gift?: Maybe<Shop_OrderHistory_Gift>;
  id: Scalars['ID']['output'];
  purchaseOrderId?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<Shop_OrderHistory_Address>;
  trackingNumbers?: Maybe<Array<Scalars['String']['output']>>;
};

export type Shop_OrderHistory_Money = {
  __typename?: 'shop_orderHistory_Money';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

/** An object with an ID. */
export type Shop_OrderHistory_Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

/** Information about pagination in a connection. */
export type Shop_OrderHistory_PageInfo = {
  __typename?: 'shop_orderHistory_PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Shop_OrderHistory_PurchaseOrder = Shop_OrderHistory_Node & {
  __typename?: 'shop_orderHistory_PurchaseOrder';
  actions: Shop_OrderHistory_Action;
  /** This field is now deprecated, consider using totalAmountPaid field instead */
  amountPaid: Scalars['String']['output'];
  createdTimestamp: Scalars['shop_orderHistory_ISO8601DateTime']['output'];
  estimatedDeliveryDates: Shop_OrderHistory_EstimatedDeliveryDates;
  id: Scalars['ID']['output'];
  itemCount: Scalars['Int']['output'];
  orderNumber: Scalars['Int']['output'];
  purchaseOrderLineItems: Shop_OrderHistory_PurchaseOrderLineItemConnection;
  shippingAddress?: Maybe<Shop_OrderHistory_Address>;
  state?: Maybe<Shop_OrderHistory_PurchaseOrderStatus>;
  totalAmountPaid: Shop_OrderHistory_Money;
};


export type Shop_OrderHistory_PurchaseOrderPurchaseOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for PurchaseOrder. */
export type Shop_OrderHistory_PurchaseOrderConnection = {
  __typename?: 'shop_orderHistory_PurchaseOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Shop_OrderHistory_PurchaseOrderEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: Shop_OrderHistory_PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Shop_OrderHistory_PurchaseOrderEdge = {
  __typename?: 'shop_orderHistory_PurchaseOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Shop_OrderHistory_PurchaseOrder>;
};

export type Shop_OrderHistory_PurchaseOrderLineItem = Shop_OrderHistory_Node & {
  __typename?: 'shop_orderHistory_PurchaseOrderLineItem';
  id: Scalars['ID']['output'];
  poliNumber: Scalars['Int']['output'];
};

/** The connection type for PurchaseOrderLineItem. */
export type Shop_OrderHistory_PurchaseOrderLineItemConnection = {
  __typename?: 'shop_orderHistory_PurchaseOrderLineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<Shop_OrderHistory_PurchaseOrderLineItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: Shop_OrderHistory_PageInfo;
};

/** An edge in a connection. */
export type Shop_OrderHistory_PurchaseOrderLineItemEdge = {
  __typename?: 'shop_orderHistory_PurchaseOrderLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Shop_OrderHistory_PurchaseOrderLineItem>;
};

export enum Shop_OrderHistory_PurchaseOrderState {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Failed = 'FAILED',
  Hold = 'HOLD',
  Paid = 'PAID',
  Partial = 'PARTIAL',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Queued = 'QUEUED',
  Redo = 'REDO',
  Shipped = 'SHIPPED',
  Unpaid = 'UNPAID'
}

export type Shop_OrderHistory_PurchaseOrderStatus = {
  __typename?: 'shop_orderHistory_PurchaseOrderStatus';
  name: Shop_OrderHistory_PurchaseOrderState;
};

export type Shop_PreviewReference_Artist = {
  __typename?: 'shop_previewReference_Artist';
  analyticsCode?: Maybe<Scalars['String']['output']>;
  artistId: Scalars['String']['output'];
  avatarUrl: Scalars['String']['output'];
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  established: Scalars['Boolean']['output'];
  externalSites: Array<Shop_PreviewReference_ArtistExternalSite>;
  fanArtist: Scalars['Boolean']['output'];
  featuredArtist: Scalars['Boolean']['output'];
  followerCount?: Maybe<Scalars['Int']['output']>;
  followingCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use artistId */
  id: Scalars['ID']['output'];
  joinedDate: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  shopUrl?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type Shop_PreviewReference_ArtistExternalSite = {
  __typename?: 'shop_previewReference_ArtistExternalSite';
  label: Scalars['String']['output'];
  site: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Generic nested key value type */
export type Shop_PreviewReference_Attribute = {
  __typename?: 'shop_previewReference_Attribute';
  attributes: Array<Shop_PreviewReference_Attribute>;
  name: Scalars['String']['output'];
  value: Scalars['shop_previewReference_Any']['output'];
};

/** Catalogue of inventory items and available configuration options */
export type Shop_PreviewReference_CategorySet = {
  __typename?: 'shop_previewReference_CategorySet';
  categoryName: Scalars['String']['output'];
  configurationSet: Array<Shop_PreviewReference_Attribute>;
  defaultItem: Shop_PreviewReference_ProductSetItem;
  defaultItems: Array<Shop_PreviewReference_ProductSetItem>;
  id: Scalars['ID']['output'];
  items: Array<Shop_PreviewReference_ProductSetItem>;
  work: Shop_PreviewReference_Work;
};


/** Catalogue of inventory items and available configuration options */
export type Shop_PreviewReference_CategorySetWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** A size guide table */
export type Shop_PreviewReference_DimensionGuide = {
  __typename?: 'shop_previewReference_DimensionGuide';
  columns: Array<Shop_PreviewReference_Attribute>;
  fixedFirstColumn: Scalars['Boolean']['output'];
  rows: Array<Shop_PreviewReference_Attribute>;
};

/** Product dimensions */
export type Shop_PreviewReference_Dimensions = {
  __typename?: 'shop_previewReference_Dimensions';
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  unit: Shop_PreviewReference_Unit;
  width: Scalars['Float']['output'];
};

export type Shop_PreviewReference_InStockStatus = Shop_PreviewReference_StockStatus & {
  __typename?: 'shop_previewReference_InStockStatus';
  /** Always 'in-stock' */
  status: Scalars['String']['output'];
};

/** A single inventory item */
export type Shop_PreviewReference_InventoryItem = {
  __typename?: 'shop_previewReference_InventoryItem';
  attributes: Array<Shop_PreviewReference_Attribute>;
  blankItemId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  features: Array<Scalars['String']['output']>;
  hasSizeGuide: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Intended for use as a longer-form description in the style selector on mobile and the web.
   * For example: 'Super soft tee, crew neck, regular fit'.
   */
  longStyleDescription: Scalars['String']['output'];
  preview?: Maybe<Shop_PreviewReference_Preview>;
  previewSet?: Maybe<Shop_PreviewReference_PreviewSet>;
  price?: Maybe<Shop_PreviewReference_Price>;
  /** @deprecated Use InventoryItem.features */
  productInfo: Shop_PreviewReference_ProductInfo;
  productPageUrl?: Maybe<Scalars['String']['output']>;
  productPageUrls?: Maybe<Shop_PreviewReference_ProductUrl>;
  productTypeId: Scalars['String']['output'];
  /**
   * stockStatus will always be "in stock" if country is not passed. This is for
   * backward compatibility reasons: clients that are not yet configured to send
   * the shipping country can't suddenly find everything is out of stock.
   */
  stockStatus: Shop_PreviewReference_StockStatus;
  volumeDiscount?: Maybe<Shop_PreviewReference_VolumeDiscount>;
  work: Shop_PreviewReference_Work;
  workId: Scalars['Int']['output'];
};


/** A single inventory item */
export type Shop_PreviewReference_InventoryItemPreviewArgs = {
  previewTypeId?: InputMaybe<Scalars['String']['input']>;
};


/** A single inventory item */
export type Shop_PreviewReference_InventoryItemPreviewSetArgs = {
  previewTypeIds: Array<Scalars['String']['input']>;
};


/** A single inventory item */
export type Shop_PreviewReference_InventoryItemPriceArgs = {
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
};


/** A single inventory item */
export type Shop_PreviewReference_InventoryItemProductPageUrlArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
};


/** A single inventory item */
export type Shop_PreviewReference_InventoryItemProductPageUrlsArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
};


/** A single inventory item */
export type Shop_PreviewReference_InventoryItemWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A single inventory item contained within a collection.
 * See InventoryItem for more detailed field descriptions.
 */
export type Shop_PreviewReference_InventoryItemsItem = {
  __typename?: 'shop_previewReference_InventoryItemsItem';
  attributes: Array<Shop_PreviewReference_Attribute>;
  blankItemId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  features: Array<Scalars['String']['output']>;
  hasSizeGuide: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  longStyleDescription: Scalars['String']['output'];
  preview?: Maybe<Shop_PreviewReference_Preview>;
  previewSet?: Maybe<Shop_PreviewReference_PreviewSet>;
  price?: Maybe<Shop_PreviewReference_Price>;
  /** @deprecated Use InventoryItemsItem.features */
  productInfo: Shop_PreviewReference_ProductInfo;
  /**
   * productPageUrl is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'ProductUrl.url' field.
   */
  productPageUrl?: Maybe<Scalars['String']['output']>;
  productPageUrls?: Maybe<Shop_PreviewReference_ProductUrl>;
  productTypeId: Scalars['String']['output'];
  /** See InventoryItem.stockStatus for caveats */
  stockStatus: Shop_PreviewReference_StockStatus;
  volumeDiscount?: Maybe<Shop_PreviewReference_VolumeDiscount>;
  work: Shop_PreviewReference_Work;
  workId: Scalars['Int']['output'];
};


/**
 * A single inventory item contained within a collection.
 * See InventoryItem for more detailed field descriptions.
 */
export type Shop_PreviewReference_InventoryItemsItemPreviewArgs = {
  previewTypeId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A single inventory item contained within a collection.
 * See InventoryItem for more detailed field descriptions.
 */
export type Shop_PreviewReference_InventoryItemsItemWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type Shop_PreviewReference_NoopEntityToWorkAroundFederationBug = {
  __typename?: 'shop_previewReference_NoopEntityToWorkAroundFederationBug';
  id: Scalars['ID']['output'];
};

export type Shop_PreviewReference_OutOfStockStatus = Shop_PreviewReference_StockStatus & {
  __typename?: 'shop_previewReference_OutOfStockStatus';
  /** Always 'out-of-stock' */
  status: Scalars['String']['output'];
};

export type Shop_PreviewReference_PresaleStockStatus = Shop_PreviewReference_StockStatus & {
  __typename?: 'shop_previewReference_PresaleStockStatus';
  /** Always 'presale' */
  status: Scalars['String']['output'];
};

/** A preview with its preview type ID and Magickraum URL */
export type Shop_PreviewReference_Preview = {
  __typename?: 'shop_previewReference_Preview';
  /**
   * All available formats for this preview (image/jpeg, image/webp). There
   *   should be one and only one format marked as default. The default format in
   *   this list will also be available as 'url' and 'mime' in the Preview type.
   */
  formats: Array<Shop_PreviewReference_PreviewFormat>;
  id: Scalars['ID']['output'];
  /** Mime type of the fallback format from formats */
  mime: Scalars['String']['output'];
  previewTypeId: Scalars['String']['output'];
  /** URL of the fallback format from formats */
  url: Scalars['String']['output'];
};

export type Shop_PreviewReference_PreviewFormat = {
  __typename?: 'shop_previewReference_PreviewFormat';
  fallback: Scalars['Boolean']['output'];
  mime: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A wrapper for one or more Previews to annotate with inventory item id */
export type Shop_PreviewReference_PreviewItem = {
  __typename?: 'shop_previewReference_PreviewItem';
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['ID']['output'];
  item: Array<Shop_PreviewReference_Preview>;
};

/** Set of previews with urls */
export type Shop_PreviewReference_PreviewSet = {
  __typename?: 'shop_previewReference_PreviewSet';
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['ID']['output'];
  previews: Array<Shop_PreviewReference_Preview>;
};

/** Represents a price with currency */
export type Shop_PreviewReference_Price = {
  __typename?: 'shop_previewReference_Price';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  discount: Shop_PreviewReference_PromoDiscount;
  id: Scalars['ID']['output'];
};

/** Wrapper type for product description */
export type Shop_PreviewReference_ProductInfo = {
  __typename?: 'shop_previewReference_ProductInfo';
  /** @deprecated Use features in InventoryItem, InventoryItemsItem or ProductSetItem */
  longDescription: Array<Scalars['String']['output']>;
};

export type Shop_PreviewReference_ProductPageUrls = {
  __typename?: 'shop_previewReference_ProductPageUrls';
  /**
   * fallbackUrl is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'ProductUrl.url' field.
   */
  fallbackUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * url is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'ProductUrl.url' field.
   */
  url?: Maybe<Scalars['String']['output']>;
};

/** A single inventory item contained within a CategorySet */
export type Shop_PreviewReference_ProductSetItem = {
  __typename?: 'shop_previewReference_ProductSetItem';
  attributes: Array<Shop_PreviewReference_Attribute>;
  blankItemId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  features: Array<Scalars['String']['output']>;
  hasSizeGuide: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  longStyleDescription: Scalars['String']['output'];
  preview?: Maybe<Shop_PreviewReference_Preview>;
  previewSet?: Maybe<Shop_PreviewReference_PreviewSet>;
  price?: Maybe<Shop_PreviewReference_Price>;
  /** @deprecated Use ProductSetItem.features */
  productInfo: Shop_PreviewReference_ProductInfo;
  /**
   * productPageUrl is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'ProductUrl.url' field.
   */
  productPageUrl?: Maybe<Scalars['String']['output']>;
  productPageUrls?: Maybe<Shop_PreviewReference_ProductPageUrls>;
  productTypeId: Scalars['String']['output'];
  /** See InventoryItem.stockStatus for caveats */
  stockStatus: Shop_PreviewReference_StockStatus;
  volumeDiscount?: Maybe<Shop_PreviewReference_VolumeDiscount>;
  work: Shop_PreviewReference_Work;
  workId: Scalars['Int']['output'];
};


/** A single inventory item contained within a CategorySet */
export type Shop_PreviewReference_ProductSetItemPreviewArgs = {
  previewTypeId?: InputMaybe<Scalars['String']['input']>;
};


/** A single inventory item contained within a CategorySet */
export type Shop_PreviewReference_ProductSetItemWorkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** A Product URL */
export type Shop_PreviewReference_ProductUrl = {
  __typename?: 'shop_previewReference_ProductUrl';
  /**
   * fallbackUrl is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients except under the rules outlined in the 'url' field.
   */
  fallbackUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * url is an opaque, full URL, including scheme, authority, path, query and also potentially
   * fragment. It should not be modified by clients EXCEPT under the following circumstances:
   *
   * - To add (but not remove or modify) query string parameters
   * - To add a fragment _iff_ the client knows itself to be the target of the URL AND
   *   there is no fragment already
   * - To modify the authority _iff_ the client knows itself to be the target of the URL
   *   (this would likely be envronment specific, and this rule is mostly intended for
   *   facilitating local development)
   *
   * All other parts of the URL, in all other circumstances, should be left exactly as
   * they are received.
   */
  url?: Maybe<Scalars['String']['output']>;
};

/** A wrapper for one or more Product URLs to annotate with inventory item id */
export type Shop_PreviewReference_ProductUrlItem = {
  __typename?: 'shop_previewReference_ProductUrlItem';
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['String']['output'];
  item: Shop_PreviewReference_ProductUrl;
  locale?: Maybe<Scalars['String']['output']>;
};

/** Represents a promotional discount of a price */
export type Shop_PreviewReference_PromoDiscount = {
  __typename?: 'shop_previewReference_PromoDiscount';
  amount: Scalars['Float']['output'];
  percent: Scalars['Float']['output'];
};

/**
 * XXX 20250805: We are leaving space for individual stock statuses to have their own
 * sets of fields. This is not in use at the time of writing, but we want to make sure
 * the option is available. Consuming systems MUST NOT close this door. Fields may be
 * added at the interface level, or the type level.
 */
export type Shop_PreviewReference_StockStatus = {
  status: Scalars['String']['output'];
};

export enum Shop_PreviewReference_Unit {
  Cm = 'CM',
  In = 'IN'
}

export type Shop_PreviewReference_VolumeDiscount = {
  __typename?: 'shop_previewReference_VolumeDiscount';
  id: Scalars['ID']['output'];
  thresholds: Array<Shop_PreviewReference_VolumeDiscountThreshold>;
};

export type Shop_PreviewReference_VolumeDiscountThreshold = {
  __typename?: 'shop_previewReference_VolumeDiscountThreshold';
  percentOff: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type Shop_PreviewReference_Work = {
  __typename?: 'shop_previewReference_Work';
  artist?: Maybe<Shop_PreviewReference_Artist>;
  artistDisplayName: Scalars['String']['output'];
  artistShopDisplayName?: Maybe<Scalars['String']['output']>;
  artistUsername: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use workId */
  id: Scalars['ID']['output'];
  isMachineTranslated: Scalars['Boolean']['output'];
  licensed: Scalars['Boolean']['output'];
  linkBackTags: Array<Scalars['String']['output']>;
  matureContent: Scalars['Boolean']['output'];
  originalLocale?: Maybe<Scalars['String']['output']>;
  portfolioPreview?: Maybe<Shop_PreviewReference_Preview>;
  productPageIndexable: Scalars['Boolean']['output'];
  /**
   * remoteKey contains the imagehaus image ID for either the :print image type, or
   *   a fallback image type. It has been used for constructing certain previews in the
   *   past, but see the deprecation notice for more details and please do not use it in
   *   future.
   * @deprecated This should not be used, especially not for constructing magickraum URLs by
   * hand; the Preview Reference API contained herein should perform that role. If
   * it does not satisfy a particular use case or it is not available at the point
   * in the graph you require, instead of using this, please reach out.
   */
  remoteKey?: Maybe<Scalars['String']['output']>;
  /** 'tags' is deprecated; use tagsOriginal or tagsCleaned */
  tags: Array<Scalars['String']['output']>;
  /** 'tagsCleaned' contains normalised tags, stripped of product synonyms */
  tagsCleaned: Array<Scalars['String']['output']>;
  /** 'tagsOriginal' contains the exact unmodified tags array we received from the monolith */
  tagsOriginal: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  workId: Scalars['Int']['output'];
};

export type Shop_PreviewReference__Entity = Shop_PreviewReference_NoopEntityToWorkAroundFederationBug;

export type Shop_PreviewReference__Service = {
  __typename?: 'shop_previewReference__Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type Shop_Promotions_ApplicableVolumeDiscount = {
  __typename?: 'shop_promotions_ApplicableVolumeDiscount';
  discount?: Maybe<Shop_Promotions_VolumeDiscount>;
  id: Scalars['ID']['output'];
  inventoryItemId: Scalars['String']['output'];
};

export type Shop_Promotions_Threshold = {
  __typename?: 'shop_promotions_Threshold';
  percentOff: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type Shop_Promotions_VolumeDiscount = {
  __typename?: 'shop_promotions_VolumeDiscount';
  id: Scalars['ID']['output'];
  thresholds: Array<Shop_Promotions_Threshold>;
};

export type GetDefaultCategoryIdQueryVariables = Exact<{
  blankItemId: Scalars['String']['input'];
}>;


export type GetDefaultCategoryIdQuery = { __typename?: 'Query', shop_defaultCategoryId?: string | null };

export type GetCategorySetQueryVariables = Exact<{
  workId: Scalars['Int']['input'];
  categoryId: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  previewTypeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  unit: Shop_Inventory_Unit;
}>;


export type GetCategorySetQuery = { __typename?: 'Query', shop_inventory_categorySet?: { __typename?: 'shop_inventory_CategorySet', id: string, categoryName: string, configurationSet: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any, attributes: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any }> }>, defaultItem: { __typename?: 'shop_inventory_ProductSetItem', id: string, workId: number, productTypeId: string, blankItemId: string, description: string, measurementSummary?: string | null, hasSizeGuide: boolean, productPageUrl?: string | null, marketingProductTypeId?: string | null, gaCode?: string | null, gaCategory?: string | null, tagCloudIaCode?: string | null, work: { __typename?: 'shop_inventory_Work', id: string, artistUsername: string, artistShopDisplayName?: string | null, title: string, description?: string | null, url: string, matureContent: boolean, tags: Array<string>, licensed: boolean, isMachineTranslated: boolean, productPageIndexable: boolean, originalLocale?: string | null, linkBackTags: Array<string>, artist?: { __typename?: 'shop_Artist', id: string, name: string, username: string, shopDisplayName: string, avatar: string, profileUrl?: string | null, established: boolean, featuredArtist: boolean, fanArtist: boolean, externalSites: Array<{ __typename?: 'shop_ExternalSite', label: string, site: string, url: string }> } | null, portfolioPreview?: { __typename?: 'shop_inventory_Preview', url: string } | null, lists?: { __typename?: 'shop_lists_Inclusion', id: string, lists?: Array<{ __typename?: 'shop_lists_ListId', listId: string }> | null } | null }, attributes: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any, attributes: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any }> }>, price?: { __typename?: 'shop_inventory_Price', id: string, amount: number, currency: string, discount: { __typename?: 'shop_inventory_PromoDiscount', amount: number, percent: number } } | null, previewSet?: { __typename?: 'shop_inventory_PreviewSet', previews: Array<{ __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string, tag: string, formats: Array<{ __typename?: 'shop_inventory_PreviewFormat', url: string, mime: string, fallback: boolean }> }> } | null, experiences: Array<{ __typename?: 'shop_Attribute', name: string, value: any }>, volumeDiscount?: { __typename?: 'shop_inventory_VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'shop_inventory_VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
        | { __typename?: 'shop_inventory_InStockStatus', status: string }
        | { __typename?: 'shop_inventory_OutOfStockStatus', status: string }
        | { __typename?: 'shop_inventory_PresaleStockStatus', status: string }
       }, items: Array<{ __typename?: 'shop_inventory_ProductSetItem', id: string, workId: number, productTypeId: string, blankItemId: string, description: string, measurementSummary?: string | null, hasSizeGuide: boolean, productPageUrl?: string | null, marketingProductTypeId?: string | null, gaCode?: string | null, gaCategory?: string | null, tagCloudIaCode?: string | null, attributes: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any, attributes: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any }> }>, price?: { __typename?: 'shop_inventory_Price', id: string, amount: number, currency: string, discount: { __typename?: 'shop_inventory_PromoDiscount', amount: number, percent: number } } | null, previewSet?: { __typename?: 'shop_inventory_PreviewSet', previews: Array<{ __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string, tag: string, formats: Array<{ __typename?: 'shop_inventory_PreviewFormat', url: string, mime: string, fallback: boolean }> }> } | null, experiences: Array<{ __typename?: 'shop_Attribute', name: string, value: any }>, volumeDiscount?: { __typename?: 'shop_inventory_VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'shop_inventory_VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
        | { __typename?: 'shop_inventory_InStockStatus', status: string }
        | { __typename?: 'shop_inventory_OutOfStockStatus', status: string }
        | { __typename?: 'shop_inventory_PresaleStockStatus', status: string }
       }> } | null };

export type GetDefaultInventoryItemsQueryVariables = Exact<{
  workId: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  unit: Shop_Inventory_Unit;
}>;


export type GetDefaultInventoryItemsQuery = { __typename?: 'Query', shop_inventory_defaultInventoryItems?: Array<{ __typename?: 'shop_inventory_InventoryItemsItem', blankItemId: string, id: string, marketingProductTypeId?: string | null, productTypeId: string, description: string, gaCode?: string | null, productPageUrls?: { __typename?: 'shop_inventory_ProductUrl', url?: string | null, fallbackUrl: string } | null, previewSet?: { __typename?: 'shop_inventory_PreviewSet', previews: Array<{ __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string }> } | null, price?: { __typename?: 'shop_inventory_Price', id: string, amount: number, currency: string, discount: { __typename?: 'shop_inventory_PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'shop_inventory_VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'shop_inventory_VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
      | { __typename?: 'shop_inventory_InStockStatus', status: string }
      | { __typename?: 'shop_inventory_OutOfStockStatus', status: string }
      | { __typename?: 'shop_inventory_PresaleStockStatus', status: string }
     } | null> | null };

export type GetSimilarDesignsQueryVariables = Exact<{
  inventoryItemId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: Scalars['String']['input'];
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isBot?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSimilarDesignsQuery = { __typename?: 'Query', shop_guru_similarDesigns: { __typename?: 'shop_guru_InventoryItemRecommendations', recommendations: Array<{ __typename?: 'shop_guru_InventoryItemRecommendation', inventoryItemId: string, inventoryItem?: { __typename?: 'shop_inventory_InventoryItemsItem', blankItemId: string, gaCode?: string | null, id: string, description: string, marketingProductTypeId?: string | null, productTypeId: string, productPageUrl?: string | null, workId: number, previewSet?: { __typename?: 'shop_inventory_PreviewSet', previews: Array<{ __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string }> } | null, price?: { __typename?: 'shop_inventory_Price', id: string, amount: number, currency: string, discount: { __typename?: 'shop_inventory_PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'shop_inventory_VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'shop_inventory_VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
          | { __typename?: 'shop_inventory_InStockStatus', status: string }
          | { __typename?: 'shop_inventory_OutOfStockStatus', status: string }
          | { __typename?: 'shop_inventory_PresaleStockStatus', status: string }
        , work: { __typename?: 'shop_inventory_Work', id: string, url: string, title: string, matureContent: boolean, artistUsername: string, artistShopDisplayName?: string | null, portfolioPreview?: { __typename?: 'shop_inventory_Preview', url: string } | null } } | null }> } };

export type GetReviewSummaryQueryVariables = Exact<{
  inventoryItemId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type GetReviewSummaryQuery = { __typename?: 'Query', shop_reviewSummary?: { __typename?: 'shop_ReviewSummary', id: string, count: number, rating: number } | null };

export type GetReviewSetQueryVariables = Exact<{
  inventoryItemId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type GetReviewSetQuery = { __typename?: 'Query', shop_reviewSet?: { __typename?: 'shop_ReviewSet', id: string, reviews: Array<{ __typename?: 'shop_Review', id: string, inventoryItemId: string, productTypeId: string, authorName: string, content: string, createdAt: string, title: string, score: number }> } | null };

export type GetSizeGuideQueryVariables = Exact<{
  workId: Scalars['Int']['input'];
  productTypeId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  inventoryItemId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSizeGuideQuery = { __typename?: 'Query', shop_inventory_sizeGuide?: { __typename?: 'shop_inventory_DimensionGuide', fixedFirstColumn: boolean, columns: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any }>, rows: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any, attributes: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any }> }> } | null };

export type GetUserAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAccountQuery = { __typename?: 'Query', shop_userAccount?: { __typename?: 'shop_UserAccount', joinedAt: any, onboardedAt?: any | null, analytics?: { __typename?: 'shop_UserAccountAnalytics', artistUploadsGroup: string, artistSalesGroup: string } | null, favoritesList?: { __typename?: 'shop_List', listId: string } | null } | null };

export type GetAlternateProductPageUrlsQueryVariables = Exact<{
  inventoryItemId: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAlternateProductPageUrlsQuery = { __typename?: 'Query', shop_alternateProductPageUrls: Array<{ __typename?: 'shop_AlternateProductPageUrl', locale: string, url: string } | null> };

export type GetDeliveryDatesQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  productTypeId: Scalars['String']['input'];
  timezoneOffset: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type GetDeliveryDatesQuery = { __typename?: 'Query', shop_deliveryDates?: { __typename?: 'shop_DeliveryDates', express?: { __typename?: 'shop_DeliveryDateRange', low?: string | null, high?: string | null, type?: string | null, daysLeftToOrder?: number | null, targetDate?: string | null } | null, standard?: { __typename?: 'shop_DeliveryDateRange', low?: string | null, high?: string | null, type?: string | null, daysLeftToOrder?: number | null, targetDate?: string | null } | null } | null };

export type GetIaEntitiesCopyQueryVariables = Exact<{
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  locale: Scalars['String']['input'];
}>;


export type GetIaEntitiesCopyQuery = { __typename?: 'Query', shop_iaEntitiesCopy: Array<{ __typename?: 'shop_IaEntityCopy', iaCode: string, canonicalForm: string, pluralDisplayName: string, label: string } | null> };

export type GetListsInclusionsQueryVariables = Exact<{
  input: Shop_Lists_InclusionsInput;
}>;


export type GetListsInclusionsQuery = { __typename?: 'Query', shop_lists_inclusions?: Array<{ __typename?: 'shop_lists_Inclusion', id: string, lists?: Array<{ __typename?: 'shop_lists_ListId', listId: string }> | null }> | null };

export type GetListsQueryVariables = Exact<{
  input?: InputMaybe<Shop_Lists_ListsInput>;
}>;


export type GetListsQuery = { __typename?: 'Query', shop_lists_lists?: { __typename?: 'shop_lists_Lists', id: string, defaultList?: { __typename?: 'shop_lists_List', id: string, listId: string, name?: string | null } | null, lists?: { __typename?: 'shop_lists_ListConnection', nodes?: Array<{ __typename?: 'shop_lists_List', id: string, listId: string, name?: string | null } | null> | null } | null } | null };

export type GetArtistInventoryItemPortfolioQueryVariables = Exact<{
  inventoryItemId: Scalars['String']['input'];
  artistUsername: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  country: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetArtistInventoryItemPortfolioQuery = { __typename?: 'Query', shop_artistInventoryItemPortfolio: { __typename?: 'shop_RecommendedInventoryItems', id: string, results?: Array<{ __typename?: 'shop_RecommendedInventoryItem', inventoryItemId: string, defaultPreviewTypeId?: string | null, inventoryItem?: { __typename?: 'shop_inventory_InventoryItemsItem', blankItemId: string, gaCode?: string | null, id: string, description: string, marketingProductTypeId?: string | null, productTypeId: string, productPageUrl?: string | null, previewSet?: { __typename?: 'shop_inventory_PreviewSet', previews: Array<{ __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string }> } | null, price?: { __typename?: 'shop_inventory_Price', id: string, amount: number, currency: string, discount: { __typename?: 'shop_inventory_PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'shop_inventory_VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'shop_inventory_VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
          | { __typename?: 'shop_inventory_InStockStatus', status: string }
          | { __typename?: 'shop_inventory_OutOfStockStatus', status: string }
          | { __typename?: 'shop_inventory_PresaleStockStatus', status: string }
        , work: { __typename?: 'shop_inventory_Work', id: string, title: string, matureContent: boolean } } | null } | null> | null } };

export type GetArtistShopArtistInfoQueryVariables = Exact<{
  artistName: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
}>;


export type GetArtistShopArtistInfoQuery = { __typename?: 'Query', shop_artistShopArtistInfo?: { __typename?: 'shop_ArtistShopArtistInfo', worksCount: number, federatedId?: string | null, accountState: Shop_ArtistState, username?: string | null, shopDisplayName: string, avatar?: string | null, additionalInfo?: string | null } | null };

export type GetIsArtistFollowedQueryVariables = Exact<{
  artistId: Scalars['Int']['input'];
}>;


export type GetIsArtistFollowedQuery = { __typename?: 'Query', shop_artistDomain_isFollowing: { __typename?: 'shop_artistDomain_FollowedArtist', id: string, isFollowed: boolean } };

export type GetLicensingMarkQueryVariables = Exact<{
  workId: Scalars['Int']['input'];
}>;


export type GetLicensingMarkQuery = { __typename?: 'Query', shop_licensingMarks: Array<{ __typename?: 'shop_LicensingMark', imageSrc: string, rightsholderName: string, intellectualPropertyName: string, agreementId: string, legalLine: string }> };

export type GetLicensedProductsQueryVariables = Exact<{
  inventoryItemId: Scalars['String']['input'];
  artistUsername: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  currency: Scalars['String']['input'];
  country: Scalars['String']['input'];
  famProperty: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetLicensedProductsQuery = { __typename?: 'Query', shop_licensedInventoryItems: { __typename?: 'shop_RecommendedInventoryItems', id: string, results?: Array<{ __typename?: 'shop_RecommendedInventoryItem', inventoryItemId: string, defaultPreviewTypeId?: string | null, inventoryItem?: { __typename?: 'shop_inventory_InventoryItemsItem', blankItemId: string, gaCode?: string | null, id: string, marketingProductTypeId?: string | null, productTypeId: string, productPageUrl?: string | null, description: string, previewSet?: { __typename?: 'shop_inventory_PreviewSet', previews: Array<{ __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string }> } | null, price?: { __typename?: 'shop_inventory_Price', id: string, amount: number, currency: string, discount: { __typename?: 'shop_inventory_PromoDiscount', amount: number, percent: number } } | null, volumeDiscount?: { __typename?: 'shop_inventory_VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'shop_inventory_VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
          | { __typename?: 'shop_inventory_InStockStatus', status: string }
          | { __typename?: 'shop_inventory_OutOfStockStatus', status: string }
          | { __typename?: 'shop_inventory_PresaleStockStatus', status: string }
        , work: { __typename?: 'shop_inventory_Work', id: string, title: string, matureContent: boolean, artistShopDisplayName?: string | null } } | null } | null> | null } };

export type GetOtherProductsQueryVariables = Exact<{
  inventoryItemId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  previewTypeIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetOtherProductsQuery = { __typename?: 'Query', shop_otherProducts: Array<{ __typename?: 'shop_inventory_InventoryItemsItem', blankItemId: string, gaCode?: string | null, id: string, description: string, marketingProductTypeId?: string | null, productTypeId: string, workId: number, previewSet?: { __typename?: 'shop_inventory_PreviewSet', previews: Array<{ __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string }> } | null, volumeDiscount?: { __typename?: 'shop_inventory_VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'shop_inventory_VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
      | { __typename?: 'shop_inventory_InStockStatus', status: string }
      | { __typename?: 'shop_inventory_OutOfStockStatus', status: string }
      | { __typename?: 'shop_inventory_PresaleStockStatus', status: string }
    , productPageUrls?: { __typename?: 'shop_inventory_ProductUrl', url?: string | null, fallbackUrl: string } | null, price?: { __typename?: 'shop_inventory_Price', id: string, amount: number, currency: string, discount: { __typename?: 'shop_inventory_PromoDiscount', amount: number, percent: number } } | null, work: { __typename?: 'shop_inventory_Work', id: string, url: string, title: string, matureContent: boolean } }> };

export type GetRecommendedProductsQueryVariables = Exact<{
  inventoryItemId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  country: Scalars['String']['input'];
  previewTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRecommendedProductsQuery = { __typename?: 'Query', shop_recommendedInventoryItems: { __typename?: 'shop_RecommendedInventoryItems', results?: Array<{ __typename?: 'shop_RecommendedInventoryItem', defaultPreviewTypeId?: string | null, inventoryItem?: { __typename?: 'shop_inventory_InventoryItemsItem', id: string, marketingProductTypeId?: string | null, description: string, productPageUrl?: string | null, productTypeId: string, blankItemId: string, gaCode?: string | null, gaCategory?: string | null, price?: { __typename?: 'shop_inventory_Price', amount: number, currency: string, discount: { __typename?: 'shop_inventory_PromoDiscount', amount: number, percent: number } } | null, previewSet?: { __typename?: 'shop_inventory_PreviewSet', previews: Array<{ __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string }> } | null, volumeDiscount?: { __typename?: 'shop_inventory_VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'shop_inventory_VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
          | { __typename?: 'shop_inventory_InStockStatus', status: string }
          | { __typename?: 'shop_inventory_OutOfStockStatus', status: string }
          | { __typename?: 'shop_inventory_PresaleStockStatus', status: string }
        , attributes: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any, attributes: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any }> }>, experiencesProductCard: Array<{ __typename?: 'shop_Attribute', name: string, value: any }>, work: { __typename?: 'shop_inventory_Work', id: string, title: string, artistShopDisplayName?: string | null, matureContent: boolean, tags: Array<string> } } | null } | null> | null } };

export type CreateAnonymousUserMutationVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAnonymousUserMutation = { __typename?: 'Mutation', shop_createAnonymousUser?: { __typename?: 'shop_UserInfo', userId?: string | null } | null };

export type AddToCartMutationVariables = Exact<{
  inventoryItemId: Scalars['String']['input'];
}>;


export type AddToCartMutation = { __typename?: 'Mutation', shop_addToCart?: { __typename?: 'shop_cart_Cart', id: string, totalItems: number } | null };

export type FollowArtistMutationVariables = Exact<{
  artistId: Scalars['Int']['input'];
}>;


export type FollowArtistMutation = { __typename?: 'Mutation', shop_artistDomain_followArtist?: { __typename?: 'shop_artistDomain_FollowedArtist', id: string, isFollowed: boolean } | null };

export type UnfollowArtistMutationVariables = Exact<{
  artistId: Scalars['Int']['input'];
}>;


export type UnfollowArtistMutation = { __typename?: 'Mutation', shop_artistDomain_unfollowArtist?: { __typename?: 'shop_artistDomain_FollowedArtist', id: string, isFollowed: boolean } | null };

export type AddItemOrWorkToListMutationVariables = Exact<{
  input: Shop_Lists_AddItemToListInput;
}>;


export type AddItemOrWorkToListMutation = { __typename?: 'Mutation', shop_addItemToList?: { __typename?: 'shop_lists_AddItemToListPayload', inclusions?: { __typename?: 'shop_lists_Inclusion', item?:
        | { __typename?: 'shop_lists_InventoryItemItem', entityId: string, id: string }
        | { __typename?: 'shop_lists_WorkItem', entityId: string, id: string }
       | null, lists?: Array<{ __typename?: 'shop_lists_ListId', id: string, listId: string }> | null } | null } | null };

export type RemoveItemOrWorkFromListMutationVariables = Exact<{
  input: Shop_Lists_RemoveItemFromListInput;
}>;


export type RemoveItemOrWorkFromListMutation = { __typename?: 'Mutation', shop_removeItemFromList?: { __typename?: 'shop_lists_RemoveItemFromListPayload', inclusions?: { __typename?: 'shop_lists_Inclusion', item?:
        | { __typename?: 'shop_lists_InventoryItemItem', entityId: string, id: string }
        | { __typename?: 'shop_lists_WorkItem', entityId: string, id: string }
       | null, lists?: Array<{ __typename?: 'shop_lists_ListId', id: string, listId: string }> | null } | null } | null };

export type AddItemOrWorkToDefaultListMutationVariables = Exact<{
  input: Shop_Lists_AddItemToDefaultListInput;
}>;


export type AddItemOrWorkToDefaultListMutation = { __typename?: 'Mutation', shop_addItemToDefaultList?: { __typename?: 'shop_lists_AddItemToDefaultListPayload', defaultList?: { __typename?: 'shop_lists_List', listId: string, name?: string | null } | null, inclusions?: { __typename?: 'shop_lists_Inclusion', item?:
        | { __typename?: 'shop_lists_InventoryItemItem', entityId: string, id: string }
        | { __typename?: 'shop_lists_WorkItem', entityId: string, id: string }
       | null, lists?: Array<{ __typename?: 'shop_lists_ListId', id: string, listId: string }> | null } | null } | null };

export type CreateListMutationVariables = Exact<{
  input: Shop_Lists_CreateListInput;
}>;


export type CreateListMutation = { __typename?: 'Mutation', shop_createList?: { __typename?: 'shop_lists_CreateListPayload', list?: { __typename?: 'shop_lists_List', id: string, listId: string, name?: string | null } | null } | null };

export type InventoryItemFragment = { __typename?: 'shop_inventory_ProductSetItem', id: string, workId: number, productTypeId: string, blankItemId: string, description: string, measurementSummary?: string | null, hasSizeGuide: boolean, productPageUrl?: string | null, marketingProductTypeId?: string | null, gaCode?: string | null, gaCategory?: string | null, tagCloudIaCode?: string | null, attributes: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any, attributes: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any }> }>, price?: { __typename?: 'shop_inventory_Price', id: string, amount: number, currency: string, discount: { __typename?: 'shop_inventory_PromoDiscount', amount: number, percent: number } } | null, previewSet?: { __typename?: 'shop_inventory_PreviewSet', previews: Array<{ __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string, tag: string, formats: Array<{ __typename?: 'shop_inventory_PreviewFormat', url: string, mime: string, fallback: boolean }> }> } | null, experiences: Array<{ __typename?: 'shop_Attribute', name: string, value: any }>, volumeDiscount?: { __typename?: 'shop_inventory_VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'shop_inventory_VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
    | { __typename?: 'shop_inventory_InStockStatus', status: string }
    | { __typename?: 'shop_inventory_OutOfStockStatus', status: string }
    | { __typename?: 'shop_inventory_PresaleStockStatus', status: string }
   };

export type DefaultInventoryItemFragment = { __typename?: 'shop_inventory_ProductSetItem', id: string, workId: number, productTypeId: string, blankItemId: string, description: string, measurementSummary?: string | null, hasSizeGuide: boolean, productPageUrl?: string | null, marketingProductTypeId?: string | null, gaCode?: string | null, gaCategory?: string | null, tagCloudIaCode?: string | null, work: { __typename?: 'shop_inventory_Work', id: string, artistUsername: string, artistShopDisplayName?: string | null, title: string, description?: string | null, url: string, matureContent: boolean, tags: Array<string>, licensed: boolean, isMachineTranslated: boolean, productPageIndexable: boolean, originalLocale?: string | null, linkBackTags: Array<string>, artist?: { __typename?: 'shop_Artist', id: string, name: string, username: string, shopDisplayName: string, avatar: string, profileUrl?: string | null, established: boolean, featuredArtist: boolean, fanArtist: boolean, externalSites: Array<{ __typename?: 'shop_ExternalSite', label: string, site: string, url: string }> } | null, portfolioPreview?: { __typename?: 'shop_inventory_Preview', url: string } | null, lists?: { __typename?: 'shop_lists_Inclusion', id: string, lists?: Array<{ __typename?: 'shop_lists_ListId', listId: string }> | null } | null }, attributes: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any, attributes: Array<{ __typename?: 'shop_inventory_Attribute', name: string, value: any }> }>, price?: { __typename?: 'shop_inventory_Price', id: string, amount: number, currency: string, discount: { __typename?: 'shop_inventory_PromoDiscount', amount: number, percent: number } } | null, previewSet?: { __typename?: 'shop_inventory_PreviewSet', previews: Array<{ __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string, tag: string, formats: Array<{ __typename?: 'shop_inventory_PreviewFormat', url: string, mime: string, fallback: boolean }> }> } | null, experiences: Array<{ __typename?: 'shop_Attribute', name: string, value: any }>, volumeDiscount?: { __typename?: 'shop_inventory_VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'shop_inventory_VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
    | { __typename?: 'shop_inventory_InStockStatus', status: string }
    | { __typename?: 'shop_inventory_OutOfStockStatus', status: string }
    | { __typename?: 'shop_inventory_PresaleStockStatus', status: string }
   };

type StockStatus_Shop_Inventory_InStockStatus_Fragment = { __typename?: 'shop_inventory_InStockStatus', status: string };

type StockStatus_Shop_Inventory_OutOfStockStatus_Fragment = { __typename?: 'shop_inventory_OutOfStockStatus', status: string };

type StockStatus_Shop_Inventory_PresaleStockStatus_Fragment = { __typename?: 'shop_inventory_PresaleStockStatus', status: string };

export type StockStatusFragment =
  | StockStatus_Shop_Inventory_InStockStatus_Fragment
  | StockStatus_Shop_Inventory_OutOfStockStatus_Fragment
  | StockStatus_Shop_Inventory_PresaleStockStatus_Fragment
;

export type VolumeDiscountFragment = { __typename?: 'shop_inventory_VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'shop_inventory_VolumeDiscountThreshold', percentOff: number, quantity: number }> };

export type PriceFragment = { __typename?: 'shop_inventory_Price', id: string, amount: number, currency: string, discount: { __typename?: 'shop_inventory_PromoDiscount', amount: number, percent: number } };

export type PreviewSetFragment = { __typename?: 'shop_inventory_PreviewSet', previews: Array<{ __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string, tag: string, formats: Array<{ __typename?: 'shop_inventory_PreviewFormat', url: string, mime: string, fallback: boolean }> }> };

export type PreviewFormatFragment = { __typename?: 'shop_inventory_PreviewFormat', url: string, mime: string, fallback: boolean };

export type PreviewFragment = { __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string, tag: string, formats: Array<{ __typename?: 'shop_inventory_PreviewFormat', url: string, mime: string, fallback: boolean }> };

export type WorkFragment = { __typename?: 'shop_inventory_Work', id: string, artistUsername: string, artistShopDisplayName?: string | null, title: string, description?: string | null, url: string, matureContent: boolean, tags: Array<string>, licensed: boolean, isMachineTranslated: boolean, productPageIndexable: boolean, originalLocale?: string | null, linkBackTags: Array<string>, artist?: { __typename?: 'shop_Artist', id: string, name: string, username: string, shopDisplayName: string, avatar: string, profileUrl?: string | null, established: boolean, featuredArtist: boolean, fanArtist: boolean, externalSites: Array<{ __typename?: 'shop_ExternalSite', label: string, site: string, url: string }> } | null, portfolioPreview?: { __typename?: 'shop_inventory_Preview', url: string } | null, lists?: { __typename?: 'shop_lists_Inclusion', id: string, lists?: Array<{ __typename?: 'shop_lists_ListId', listId: string }> | null } | null };

export type ArtistFragment = { __typename?: 'shop_Artist', id: string, name: string, username: string, shopDisplayName: string, avatar: string, profileUrl?: string | null, established: boolean, featuredArtist: boolean, fanArtist: boolean, externalSites: Array<{ __typename?: 'shop_ExternalSite', label: string, site: string, url: string }> };

export type DeliveryDateRangeFragment = { __typename?: 'shop_DeliveryDateRange', low?: string | null, high?: string | null, type?: string | null, daysLeftToOrder?: number | null, targetDate?: string | null };

export type AlsoAvailableOnFragment = { __typename?: 'shop_inventory_InventoryItemsItem', blankItemId: string, gaCode?: string | null, id: string, description: string, marketingProductTypeId?: string | null, productTypeId: string, workId: number, previewSet?: { __typename?: 'shop_inventory_PreviewSet', previews: Array<{ __typename?: 'shop_inventory_Preview', previewTypeId: string, url: string }> } | null, volumeDiscount?: { __typename?: 'shop_inventory_VolumeDiscount', id: string, thresholds: Array<{ __typename?: 'shop_inventory_VolumeDiscountThreshold', percentOff: number, quantity: number }> } | null, stockStatus:
    | { __typename?: 'shop_inventory_InStockStatus', status: string }
    | { __typename?: 'shop_inventory_OutOfStockStatus', status: string }
    | { __typename?: 'shop_inventory_PresaleStockStatus', status: string }
  , productPageUrls?: { __typename?: 'shop_inventory_ProductUrl', url?: string | null, fallbackUrl: string } | null, price?: { __typename?: 'shop_inventory_Price', id: string, amount: number, currency: string, discount: { __typename?: 'shop_inventory_PromoDiscount', amount: number, percent: number } } | null, work: { __typename?: 'shop_inventory_Work', id: string, url: string, title: string, matureContent: boolean } };

export const PriceFragmentDoc = gql`
    fragment Price on shop_inventory_Price {
  id
  amount
  currency
  discount {
    amount
    percent
  }
}
    `;
export const PreviewFormatFragmentDoc = gql`
    fragment PreviewFormat on shop_inventory_PreviewFormat {
  url
  mime
  fallback
}
    `;
export const PreviewFragmentDoc = gql`
    fragment Preview on shop_inventory_Preview {
  previewTypeId
  url
  tag
  formats {
    ...PreviewFormat
  }
}
    ${PreviewFormatFragmentDoc}`;
export const PreviewSetFragmentDoc = gql`
    fragment PreviewSet on shop_inventory_PreviewSet {
  previews {
    ...Preview
  }
}
    ${PreviewFragmentDoc}`;
export const VolumeDiscountFragmentDoc = gql`
    fragment VolumeDiscount on shop_inventory_VolumeDiscount {
  id
  thresholds {
    percentOff
    quantity
  }
}
    `;
export const InventoryItemFragmentDoc = gql`
    fragment InventoryItem on shop_inventory_ProductSetItem {
  id
  workId
  productTypeId
  blankItemId
  description
  measurementSummary
  attributes {
    name
    value
    attributes {
      name
      value
    }
  }
  price {
    ...Price
  }
  previewSet {
    ...PreviewSet
  }
  hasSizeGuide
  productPageUrl
  marketingProductTypeId
  gaCode
  gaCategory
  tagCloudIaCode
  experiences {
    name
    value
  }
  volumeDiscount {
    ...VolumeDiscount
  }
  stockStatus {
    status
  }
}
    ${PriceFragmentDoc}
${PreviewSetFragmentDoc}
${VolumeDiscountFragmentDoc}`;
export const ArtistFragmentDoc = gql`
    fragment Artist on shop_Artist {
  id
  name
  username
  shopDisplayName
  avatar
  profileUrl
  established
  featuredArtist
  fanArtist
  externalSites {
    label
    site
    url
  }
}
    `;
export const WorkFragmentDoc = gql`
    fragment Work on shop_inventory_Work {
  id
  artist {
    ...Artist
  }
  artistUsername
  artistShopDisplayName
  title
  description
  url
  matureContent
  tags
  licensed
  isMachineTranslated
  productPageIndexable
  originalLocale
  linkBackTags
  portfolioPreview {
    url
  }
  lists {
    id
    lists {
      listId
    }
  }
}
    ${ArtistFragmentDoc}`;
export const DefaultInventoryItemFragmentDoc = gql`
    fragment DefaultInventoryItem on shop_inventory_ProductSetItem {
  ...InventoryItem
  work(locale: $locale) {
    ...Work
  }
}
    ${InventoryItemFragmentDoc}
${WorkFragmentDoc}`;
export const StockStatusFragmentDoc = gql`
    fragment StockStatus on shop_inventory_StockStatus {
  status
}
    `;
export const DeliveryDateRangeFragmentDoc = gql`
    fragment DeliveryDateRange on shop_DeliveryDateRange {
  low
  high
  type
  daysLeftToOrder
  targetDate
}
    `;
export const AlsoAvailableOnFragmentDoc = gql`
    fragment AlsoAvailableOn on shop_inventory_InventoryItemsItem {
  blankItemId
  gaCode
  id
  description
  marketingProductTypeId
  productTypeId
  previewSet {
    previews {
      previewTypeId
      url
    }
  }
  volumeDiscount {
    id
    thresholds {
      percentOff
      quantity
    }
  }
  stockStatus {
    status
  }
  productPageUrls {
    url
    fallbackUrl
  }
  workId
  price {
    id
    amount
    currency
    discount {
      amount
      percent
    }
  }
  work(locale: $locale) {
    id
    url
    title
    matureContent
  }
}
    `;
export const GetDefaultCategoryIdDocument = gql`
    query GetDefaultCategoryId($blankItemId: String!) {
  shop_defaultCategoryId(blankItemId: $blankItemId)
}
    `;
export const GetCategorySetDocument = gql`
    query GetCategorySet($workId: Int!, $categoryId: String!, $groupId: String, $country: String!, $currency: String!, $locale: String!, $previewTypeIds: [String!]!, $unit: shop_inventory_Unit!) {
  shop_inventory_categorySet(
    workId: $workId
    categoryId: $categoryId
    groupId: $groupId
    country: $country
    currency: $currency
    locale: $locale
    previewTypeIds: $previewTypeIds
    unit: $unit
  ) {
    id
    categoryName
    configurationSet {
      name
      value
      attributes {
        name
        value
      }
    }
    defaultItem {
      ...DefaultInventoryItem
    }
    items {
      ...InventoryItem
    }
  }
}
    ${DefaultInventoryItemFragmentDoc}
${InventoryItemFragmentDoc}`;
export const GetDefaultInventoryItemsDocument = gql`
    query GetDefaultInventoryItems($workId: Int!, $locale: String!, $previewTypeIds: [String!], $country: String, $currency: String, $unit: shop_inventory_Unit!) {
  shop_inventory_defaultInventoryItems(
    workId: $workId
    previewTypeIds: $previewTypeIds
    unit: $unit
    country: $country
    currency: $currency
    locale: $locale
  ) {
    blankItemId
    id
    marketingProductTypeId
    productPageUrls {
      url
      fallbackUrl
    }
    productTypeId
    description
    previewSet {
      previews {
        previewTypeId
        url
      }
    }
    price {
      ...Price
    }
    volumeDiscount {
      ...VolumeDiscount
    }
    stockStatus {
      status
    }
    gaCode
  }
}
    ${PriceFragmentDoc}
${VolumeDiscountFragmentDoc}`;
export const GetSimilarDesignsDocument = gql`
    query GetSimilarDesigns($inventoryItemId: String!, $limit: Int, $locale: String!, $country: String!, $currency: String!, $previewTypeIds: [String!], $groupId: String, $isBot: Boolean) {
  shop_guru_similarDesigns(
    inventoryItemId: $inventoryItemId
    limit: $limit
    isBot: $isBot
  ) {
    recommendations {
      inventoryItemId
      inventoryItem(
        locale: $locale
        currency: $currency
        country: $country
        groupId: $groupId
        previewTypeIds: $previewTypeIds
      ) {
        blankItemId
        gaCode
        id
        description
        marketingProductTypeId
        previewSet {
          previews {
            previewTypeId
            url
          }
        }
        productTypeId
        productPageUrl
        workId
        price {
          ...Price
        }
        volumeDiscount {
          ...VolumeDiscount
        }
        stockStatus {
          status
        }
        work(locale: $locale) {
          id
          url
          title
          matureContent
          artistUsername
          artistShopDisplayName
          portfolioPreview {
            url
          }
        }
      }
    }
  }
}
    ${PriceFragmentDoc}
${VolumeDiscountFragmentDoc}`;
export const GetReviewSummaryDocument = gql`
    query GetReviewSummary($inventoryItemId: String!, $locale: String!) {
  shop_reviewSummary(inventoryItemId: $inventoryItemId, locale: $locale) {
    id
    count
    rating
  }
}
    `;
export const GetReviewSetDocument = gql`
    query GetReviewSet($inventoryItemId: String!, $locale: String!) {
  shop_reviewSet(inventoryItemId: $inventoryItemId, locale: $locale) {
    id
    reviews {
      id
      inventoryItemId
      productTypeId
      authorName
      content
      createdAt
      title
      score
    }
  }
}
    `;
export const GetSizeGuideDocument = gql`
    query GetSizeGuide($workId: Int!, $productTypeId: String!, $locale: String!, $inventoryItemId: String) {
  shop_inventory_sizeGuide(
    workId: $workId
    productTypeId: $productTypeId
    locale: $locale
    inventoryItemId: $inventoryItemId
  ) {
    fixedFirstColumn
    columns {
      name
      value
    }
    rows {
      name
      value
      attributes {
        name
        value
      }
    }
  }
}
    `;
export const GetUserAccountDocument = gql`
    query GetUserAccount {
  shop_userAccount {
    analytics {
      artistUploadsGroup
      artistSalesGroup
    }
    joinedAt
    onboardedAt
    favoritesList {
      listId
    }
  }
}
    `;
export const GetAlternateProductPageUrlsDocument = gql`
    query GetAlternateProductPageUrls($inventoryItemId: String!, $groupId: String) {
  shop_alternateProductPageUrls(
    inventoryItemId: $inventoryItemId
    groupId: $groupId
  ) {
    locale
    url
  }
}
    `;
export const GetDeliveryDatesDocument = gql`
    query GetDeliveryDates($countryCode: String!, $productTypeId: String!, $timezoneOffset: String!, $locale: String!) {
  shop_deliveryDates(
    countryCode: $countryCode
    productTypeId: $productTypeId
    timezoneOffset: $timezoneOffset
    locale: $locale
  ) {
    express {
      ...DeliveryDateRange
    }
    standard {
      ...DeliveryDateRange
    }
  }
}
    ${DeliveryDateRangeFragmentDoc}`;
export const GetIaEntitiesCopyDocument = gql`
    query GetIAEntitiesCopy($codes: [String], $locale: String!) {
  shop_iaEntitiesCopy(codes: $codes, locale: $locale) {
    iaCode
    canonicalForm
    pluralDisplayName
    label
  }
}
    `;
export const GetListsInclusionsDocument = gql`
    query GetListsInclusions($input: shop_lists_InclusionsInput!) {
  shop_lists_inclusions(input: $input) {
    id
    lists {
      listId
    }
  }
}
    `;
export const GetListsDocument = gql`
    query GetLists($input: shop_lists_ListsInput) {
  shop_lists_lists(input: $input) {
    defaultList {
      id
      listId
      name
    }
    id
    lists {
      nodes {
        id
        listId
        name
      }
    }
  }
}
    `;
export const GetArtistInventoryItemPortfolioDocument = gql`
    query GetArtistInventoryItemPortfolio($inventoryItemId: String!, $artistUsername: String!, $currency: String!, $country: String!, $limit: Int, $locale: String!, $previewTypeIds: [String!]) {
  shop_artistInventoryItemPortfolio(
    inventoryItemId: $inventoryItemId
    artistUsername: $artistUsername
    locale: $locale
    limit: $limit
  ) {
    id
    results {
      inventoryItemId
      defaultPreviewTypeId
      inventoryItem(
        locale: $locale
        currency: $currency
        country: $country
        previewTypeIds: $previewTypeIds
      ) {
        blankItemId
        gaCode
        id
        description
        marketingProductTypeId
        previewSet {
          previews {
            previewTypeId
            url
          }
        }
        productTypeId
        productPageUrl
        price {
          ...Price
        }
        volumeDiscount {
          ...VolumeDiscount
        }
        stockStatus {
          status
        }
        work(locale: $locale) {
          id
          title
          matureContent
        }
      }
    }
  }
}
    ${PriceFragmentDoc}
${VolumeDiscountFragmentDoc}`;
export const GetArtistShopArtistInfoDocument = gql`
    query GetArtistShopArtistInfo($artistName: ID!, $locale: String!) {
  shop_artistShopArtistInfo(artistName: $artistName, locale: $locale) {
    worksCount
    federatedId
    accountState
    username
    shopDisplayName
    avatar
    additionalInfo
  }
}
    `;
export const GetIsArtistFollowedDocument = gql`
    query GetIsArtistFollowed($artistId: Int!) {
  shop_artistDomain_isFollowing(artistId: $artistId) {
    id
    isFollowed
  }
}
    `;
export const GetLicensingMarkDocument = gql`
    query GetLicensingMark($workId: Int!) {
  shop_licensingMarks(workId: $workId) {
    imageSrc
    rightsholderName
    intellectualPropertyName
    agreementId
    legalLine
  }
}
    `;
export const GetLicensedProductsDocument = gql`
    query GetLicensedProducts($inventoryItemId: String!, $artistUsername: String!, $limit: Int, $currency: String!, $country: String!, $famProperty: String!, $locale: String!, $previewTypeIds: [String!]) {
  shop_licensedInventoryItems(
    inventoryItemId: $inventoryItemId
    artistUsername: $artistUsername
    famProperty: $famProperty
    locale: $locale
    limit: $limit
  ) {
    id
    results {
      inventoryItemId
      defaultPreviewTypeId
      inventoryItem(
        locale: $locale
        currency: $currency
        country: $country
        previewTypeIds: $previewTypeIds
      ) {
        blankItemId
        gaCode
        id
        marketingProductTypeId
        productTypeId
        productPageUrl
        description
        previewSet {
          previews {
            previewTypeId
            url
          }
        }
        price {
          ...Price
        }
        volumeDiscount {
          ...VolumeDiscount
        }
        stockStatus {
          status
        }
        work(locale: $locale) {
          id
          title
          matureContent
          artistShopDisplayName
        }
      }
    }
  }
}
    ${PriceFragmentDoc}
${VolumeDiscountFragmentDoc}`;
export const GetOtherProductsDocument = gql`
    query GetOtherProducts($inventoryItemId: String!, $country: String!, $currency: String!, $locale: String!, $previewTypeIds: [String!]!) {
  shop_otherProducts(
    inventoryItemId: $inventoryItemId
    country: $country
    currency: $currency
    locale: $locale
    previewTypeIds: $previewTypeIds
  ) {
    ...AlsoAvailableOn
  }
}
    ${AlsoAvailableOnFragmentDoc}`;
export const GetRecommendedProductsDocument = gql`
    query GetRecommendedProducts($inventoryItemId: String!, $locale: String!, $currency: String!, $country: String!, $previewTypeIds: [String!], $searchType: String) {
  shop_recommendedInventoryItems(
    inventoryItemId: $inventoryItemId
    locale: $locale
    currency: $currency
    country: $country
    previewTypeIds: $previewTypeIds
    searchType: $searchType
  ) {
    results {
      inventoryItem(
        locale: $locale
        country: $country
        currency: $currency
        previewTypeIds: $previewTypeIds
      ) {
        id
        marketingProductTypeId
        description
        productPageUrl
        productTypeId
        blankItemId
        price {
          amount
          currency
          discount {
            amount
            percent
          }
        }
        previewSet {
          previews {
            previewTypeId
            url
          }
        }
        volumeDiscount {
          id
          thresholds {
            percentOff
            quantity
          }
        }
        stockStatus {
          status
        }
        gaCode
        gaCategory
        attributes {
          name
          value
          attributes {
            name
            value
          }
        }
        experiencesProductCard {
          name
          value
        }
        work(locale: $locale) {
          id
          title
          artistShopDisplayName
          matureContent
          tags
        }
      }
      defaultPreviewTypeId
    }
  }
}
    `;
export const CreateAnonymousUserDocument = gql`
    mutation CreateAnonymousUser($locale: String) {
  shop_createAnonymousUser(locale: $locale) {
    userId
  }
}
    `;
export const AddToCartDocument = gql`
    mutation AddToCart($inventoryItemId: String!) {
  shop_addToCart(inventoryItemId: $inventoryItemId) {
    id
    totalItems
  }
}
    `;
export const FollowArtistDocument = gql`
    mutation FollowArtist($artistId: Int!) {
  shop_artistDomain_followArtist(artistId: $artistId) {
    id
    isFollowed
  }
}
    `;
export const UnfollowArtistDocument = gql`
    mutation UnfollowArtist($artistId: Int!) {
  shop_artistDomain_unfollowArtist(artistId: $artistId) {
    id
    isFollowed
  }
}
    `;
export const AddItemOrWorkToListDocument = gql`
    mutation AddItemOrWorkToList($input: shop_lists_AddItemToListInput!) {
  shop_addItemToList(input: $input) {
    inclusions {
      item {
        id
        ... on shop_lists_InventoryItemItem {
          entityId
        }
        ... on shop_lists_WorkItem {
          entityId
        }
      }
      lists {
        id
        listId
      }
    }
  }
}
    `;
export const RemoveItemOrWorkFromListDocument = gql`
    mutation RemoveItemOrWorkFromList($input: shop_lists_RemoveItemFromListInput!) {
  shop_removeItemFromList(input: $input) {
    inclusions {
      item {
        id
        ... on shop_lists_InventoryItemItem {
          entityId
        }
        ... on shop_lists_WorkItem {
          entityId
        }
      }
      lists {
        id
        listId
      }
    }
  }
}
    `;
export const AddItemOrWorkToDefaultListDocument = gql`
    mutation AddItemOrWorkToDefaultList($input: shop_lists_AddItemToDefaultListInput!) {
  shop_addItemToDefaultList(input: $input) {
    defaultList {
      listId
      name
    }
    inclusions {
      item {
        id
        ... on shop_lists_InventoryItemItem {
          entityId
        }
        ... on shop_lists_WorkItem {
          entityId
        }
      }
      lists {
        id
        listId
      }
    }
  }
}
    `;
export const CreateListDocument = gql`
    mutation CreateList($input: shop_lists_CreateListInput!) {
  shop_createList(input: $input) {
    list {
      id
      listId
      name
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    GetDefaultCategoryId(variables: GetDefaultCategoryIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetDefaultCategoryIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDefaultCategoryIdQuery>({ document: GetDefaultCategoryIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetDefaultCategoryId', 'query', variables);
    },
    GetCategorySet(variables: GetCategorySetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetCategorySetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCategorySetQuery>({ document: GetCategorySetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetCategorySet', 'query', variables);
    },
    GetDefaultInventoryItems(variables: GetDefaultInventoryItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetDefaultInventoryItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDefaultInventoryItemsQuery>({ document: GetDefaultInventoryItemsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetDefaultInventoryItems', 'query', variables);
    },
    GetSimilarDesigns(variables: GetSimilarDesignsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetSimilarDesignsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSimilarDesignsQuery>({ document: GetSimilarDesignsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetSimilarDesigns', 'query', variables);
    },
    GetReviewSummary(variables: GetReviewSummaryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetReviewSummaryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetReviewSummaryQuery>({ document: GetReviewSummaryDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetReviewSummary', 'query', variables);
    },
    GetReviewSet(variables: GetReviewSetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetReviewSetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetReviewSetQuery>({ document: GetReviewSetDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetReviewSet', 'query', variables);
    },
    GetSizeGuide(variables: GetSizeGuideQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetSizeGuideQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSizeGuideQuery>({ document: GetSizeGuideDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetSizeGuide', 'query', variables);
    },
    GetUserAccount(variables?: GetUserAccountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetUserAccountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserAccountQuery>({ document: GetUserAccountDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetUserAccount', 'query', variables);
    },
    GetAlternateProductPageUrls(variables: GetAlternateProductPageUrlsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetAlternateProductPageUrlsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAlternateProductPageUrlsQuery>({ document: GetAlternateProductPageUrlsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetAlternateProductPageUrls', 'query', variables);
    },
    GetDeliveryDates(variables: GetDeliveryDatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetDeliveryDatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDeliveryDatesQuery>({ document: GetDeliveryDatesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetDeliveryDates', 'query', variables);
    },
    GetIAEntitiesCopy(variables: GetIaEntitiesCopyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetIaEntitiesCopyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetIaEntitiesCopyQuery>({ document: GetIaEntitiesCopyDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetIAEntitiesCopy', 'query', variables);
    },
    GetListsInclusions(variables: GetListsInclusionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetListsInclusionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListsInclusionsQuery>({ document: GetListsInclusionsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetListsInclusions', 'query', variables);
    },
    GetLists(variables?: GetListsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetListsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetListsQuery>({ document: GetListsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetLists', 'query', variables);
    },
    GetArtistInventoryItemPortfolio(variables: GetArtistInventoryItemPortfolioQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetArtistInventoryItemPortfolioQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetArtistInventoryItemPortfolioQuery>({ document: GetArtistInventoryItemPortfolioDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetArtistInventoryItemPortfolio', 'query', variables);
    },
    GetArtistShopArtistInfo(variables: GetArtistShopArtistInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetArtistShopArtistInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetArtistShopArtistInfoQuery>({ document: GetArtistShopArtistInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetArtistShopArtistInfo', 'query', variables);
    },
    GetIsArtistFollowed(variables: GetIsArtistFollowedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetIsArtistFollowedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetIsArtistFollowedQuery>({ document: GetIsArtistFollowedDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetIsArtistFollowed', 'query', variables);
    },
    GetLicensingMark(variables: GetLicensingMarkQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetLicensingMarkQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLicensingMarkQuery>({ document: GetLicensingMarkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetLicensingMark', 'query', variables);
    },
    GetLicensedProducts(variables: GetLicensedProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetLicensedProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLicensedProductsQuery>({ document: GetLicensedProductsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetLicensedProducts', 'query', variables);
    },
    GetOtherProducts(variables: GetOtherProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetOtherProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOtherProductsQuery>({ document: GetOtherProductsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetOtherProducts', 'query', variables);
    },
    GetRecommendedProducts(variables: GetRecommendedProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetRecommendedProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRecommendedProductsQuery>({ document: GetRecommendedProductsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetRecommendedProducts', 'query', variables);
    },
    CreateAnonymousUser(variables?: CreateAnonymousUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateAnonymousUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAnonymousUserMutation>({ document: CreateAnonymousUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateAnonymousUser', 'mutation', variables);
    },
    AddToCart(variables: AddToCartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddToCartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddToCartMutation>({ document: AddToCartDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddToCart', 'mutation', variables);
    },
    FollowArtist(variables: FollowArtistMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<FollowArtistMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FollowArtistMutation>({ document: FollowArtistDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'FollowArtist', 'mutation', variables);
    },
    UnfollowArtist(variables: UnfollowArtistMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UnfollowArtistMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnfollowArtistMutation>({ document: UnfollowArtistDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UnfollowArtist', 'mutation', variables);
    },
    AddItemOrWorkToList(variables: AddItemOrWorkToListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddItemOrWorkToListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddItemOrWorkToListMutation>({ document: AddItemOrWorkToListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddItemOrWorkToList', 'mutation', variables);
    },
    RemoveItemOrWorkFromList(variables: RemoveItemOrWorkFromListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RemoveItemOrWorkFromListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveItemOrWorkFromListMutation>({ document: RemoveItemOrWorkFromListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveItemOrWorkFromList', 'mutation', variables);
    },
    AddItemOrWorkToDefaultList(variables: AddItemOrWorkToDefaultListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AddItemOrWorkToDefaultListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddItemOrWorkToDefaultListMutation>({ document: AddItemOrWorkToDefaultListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddItemOrWorkToDefaultList', 'mutation', variables);
    },
    CreateList(variables: CreateListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateListMutation>({ document: CreateListDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateList', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;